    (function() {
        function initCategoryScript() {
            var dynamicList = document.getElementById('search-cat-dynamic-list');
            var initialTopItems = [];
            if (dynamicList) {
                var initialLinks = dynamicList.querySelectorAll('.search-cat-link');
                initialLinks.forEach(function(l) {
                    var name = l.textContent.trim();
                    var url = l.getAttribute('href') || '/collections/all';
                    var key = l.getAttribute('data-cat-key') || name.toLowerCase().replace(/[^a-z0-9]/g, '-');
                    if (name) {
                        initialTopItems.push({ name: name, url: url, key: key });
                    }
                });
            }

            var categoryDataMap = {
                'top': (initialTopItems.length > 0) ? initialTopItems : [
                    { name: 'Best Sellers',   url: '/collections/best-sellers', key: 'best-sellers' },
                    { name: 'All Categories', url: '/collections/all', key: 'all' },
                    { name: 'Sofas',     url: '/collections/sofas-couches', key: 'sofas' },
                    { name: 'Beds',      url: '/collections/beds',          key: 'beds' },
                    { name: 'Dining',    url: '/collections/dining',        key: 'dining' },
                    { name: 'Wardrobes', url: '/collections/wardrobes',     key: 'wardrobes' },
                    { name: 'Tables',    url: '/collections/tables',        key: 'tables' },
                    { name: 'Chairs',    url: '/collections/chairs',        key: 'chairs' },
                    { name: 'Storage',   url: '/collections/storage',       key: 'storage' },
                    { name: 'Decor',     url: '/collections/lamps',         key: 'decor' }
                ],
                'sofas': [
                    { name: 'All Sofas',       url: '/collections/sofas-couches', key: 'sofas' },
                    { name: 'Sofa Sets',       url: '/collections/sofa-sets',     key: 'sofa-sets' },
                    { name: '2 Seater Sofas',  url: '/collections/2-seater-sofas', key: '2-seater-sofas' },
                    { name: '3 Seater Sofas',  url: '/collections/3-seater-sofas', key: '3-seater-sofas' },
                    { name: 'Sectional Sofas', url: '/collections/sectional-sofas', key: 'sectional-sofas' },
                    { name: 'L Shape Sofas',   url: '/collections/l-shape-sofas', key: 'l-shape-sofas' },
                    { name: 'Recliners',       url: '/collections/recliners', key: 'recliners' },
                    { name: 'Sofa Cum Beds',   url: '/collections/sofa-cum-beds', key: 'sofa-cum-beds' },
                    { name: 'Velvet Sofas',    url: '/collections/velvet-sofas', key: 'velvet-sofas' },
                    { name: 'Suede Sofas',     url: '/collections/suede-sofas', key: 'suede-sofas' },
                    { name: 'Boucle Sofas',    url: '/collections/boucle-sofas', key: 'boucle-sofas' },
                    { name: 'Leather Sofas',   url: '/collections/leather-sofas', key: 'leather-sofas' }
                ],
                'beds': [
                    { name: 'All Beds',       url: '/collections/beds', key: 'beds' },
                    { name: 'King Size Beds', url: '/collections/king-size-beds', key: 'king-size-beds' },
                    { name: 'Queen Size Beds',url: '/collections/queen-size-beds', key: 'queen-size-beds' },
                    { name: 'Kids Beds',      url: '/collections/kids-beds', key: 'kids-beds' },
                    { name: 'Storage Beds',   url: '/collections/storage-beds', key: 'storage-beds' },
                    { name: 'Sofa Cum Beds',  url: '/collections/sofa-cum-beds', key: 'sofa-cum-beds' }
                ],
                'dining': [
                    { name: 'All Dining',              url: '/collections/dining', key: 'dining' },
                    { name: 'Dining Sets',             url: '/collections/dining-sets', key: 'dining-sets' },
                    { name: '4 Seater Dining Tables',  url: '/collections/4-seater-dining-tables', key: '4-seater-dining-tables' },
                    { name: '6 Seater Dining Tables',  url: '/collections/6-seater-dining-tables', key: '6-seater-dining-tables' },
                    { name: 'Marble Top Dining Tables',url: '/collections/marble-top-dining-tables', key: 'marble-top-dining-tables' },
                    { name: 'Wooden Dining Tables',    url: '/collections/wooden-dining-tables', key: 'wooden-dining-tables' }
                ],
                'wardrobes': [
                    { name: 'All Wardrobes',     url: '/collections/wardrobes', key: 'wardrobes' },
                    { name: 'Wooden Wardrobes',  url: '/collections/wooden-wardrobes', key: 'wooden-wardrobes' },
                    { name: 'Sliding Wardrobes', url: '/collections/sliding-wardrobes', key: 'sliding-wardrobes' },
                    { name: '2 Door Wardrobes',  url: '/collections/2-door-wardrobe', key: '2-door-wardrobes' },
                    { name: '3 Door Wardrobes',  url: '/collections/3-door-wardrobe', key: '3-door-wardrobes' }
                ],
                'tables': [
                    { name: 'All Tables',     url: '/collections/tables', key: 'tables' },
                    { name: 'Coffee Tables',  url: '/collections/coffee-tables', key: 'coffee-tables' },
                    { name: 'Study Tables',   url: '/collections/study-tables', key: 'study-tables' },
                    { name: 'Side Tables',    url: '/collections/side-tables', key: 'side-tables' },
                    { name: 'Console Tables', url: '/collections/console-table', key: 'console-tables' },
                    { name: 'Dressing Tables',url: '/collections/dressing-tables', key: 'dressing-tables' }
                ],
                'chairs': [
                    { name: 'All Chairs',    url: '/collections/chairs', key: 'chairs' },
                    { name: 'Lounge Chairs', url: '/collections/lounge-chairs', key: 'lounge-chairs' },
                    { name: 'Dining Chairs', url: '/collections/dining-chairs', key: 'dining-chairs' },
                    { name: 'Office Chairs', url: '/collections/office-chairs', key: 'office-chairs' },
                    { name: 'Benches',       url: '/collections/benches', key: 'benches' }
                ],
                'storage': [
                    { name: 'All Storage',          url: '/collections/storage', key: 'storage' },
                    { name: 'TV Units',             url: '/collections/tv-units', key: 'tv-units' },
                    { name: 'Sideboards & Storage', url: '/collections/side-boards', key: 'side-boards' },
                    { name: 'Chest of Drawers',     url: '/collections/chest-of-drawers', key: 'chest-of-drawers' },
                    { name: 'Book Shelves',         url: '/collections/bookshelves', key: 'bookshelves' }
                ],
                'decor': [
                    { name: 'All Decor',        url: '/collections/lamps', key: 'lamps' },
                    { name: 'Lamps & Lighting', url: '/collections/lamps', key: 'lamps' },
                    { name: 'Mirrors',          url: '/collections/mirrors', key: 'mirrors' }
                ]
            };

            var currentGroupKey         = 'top';
            var currentCategoryName     = 'Best Sellers';
            var currentSearchQuery      = '';
            var dynamicList             = document.getElementById('search-cat-dynamic-list');
            var heroTitle               = document.querySelector('.search-hero-title, .search-bestsellers-title');
            var heroSubtitle            = document.querySelector('.search-hero-subtitle, .search-bestsellers-subtitle');
            var resultsHeading          = document.querySelector('.search-results-heading');
            var productGrid             = document.getElementById('landing-bestsellers-product-grid');
            var sortSelect              = document.getElementById('SearchSortBy');
            var clearFiltersWrap        = document.getElementById('clear-filters-wrap');
            var clearFiltersBtn         = document.getElementById('btn-clear-all-filters');
            var searchLandingInput      = document.getElementById('Search-In-Landing');
            var searchLandingForm       = document.querySelector('.search-landing-form');

            var rawLoadedProducts       = [];
            var currentFilteredProducts = [];
            var currentPage             = 1;
            var currentViewColumns      = 3;
            var isFetching              = false;
            var activeFetchId           = 0;

            if (!dynamicList || !productGrid) return;

            /* ── Helper to determine products per page ── */
            function getPageSize() {
                if (window.innerWidth <= 868) {
                    return 5; // Mobile: exactly 5 single-column products per page
                }
                if (currentViewColumns === 2) return 6; // 3 rows x 2 cols = 6
                if (currentViewColumns === 1) return 5; // 5 rows x 1 col = 5
                return 9; // 3 rows x 3 cols = 9 (Default desktop)
            }

            /* ── Helper to resolve category param to groupKey and item ── */
            function resolveCategoryParam(param) {
                if (!param) return null;
                var clean = param.toLowerCase().trim().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');

                // Best Sellers
                if (clean === 'best-sellers' || clean === 'best-seller' || clean === 'bestsellers' || clean === 'bestseller' || clean === 'best_sellers' || clean === 'best_seller') {
                    return { groupKey: 'top', item: categoryDataMap['top'][0] };
                }
                // All Categories
                if (clean === 'all' || clean === 'all-categories') {
                    return { groupKey: 'top', item: categoryDataMap['top'][1] };
                }

                // Common Aliases
                if (clean === 'sofa' || clean === 'sofas' || clean === 'sofas-couches' || clean === 'sofas-and-couches') {
                    return { groupKey: 'sofas', item: categoryDataMap['sofas'][0] };
                }
                if (
                    clean === 'sofa-set' || clean === 'sofa-sets' ||
                    clean === 'sofas-sets' || clean === 'sofas-set' ||
                    clean === 'sofaset' || clean === 'sofasets' ||
                    clean === 'sofa_set' || clean === 'sofa_sets' ||
                    clean.indexOf('sofa-set') !== -1 || clean.indexOf('sofaset') !== -1
                ) {
                    var sofaSetItem = categoryDataMap['sofas'].find(function(i) { return i.key === 'sofa-sets'; });
                    if (sofaSetItem) return { groupKey: 'sofas', item: sofaSetItem };
                }
                if (clean === 'bed' || clean === 'beds') {
                    return { groupKey: 'beds', item: categoryDataMap['beds'][0] };
                }
                if (clean === 'dining') {
                    return { groupKey: 'dining', item: categoryDataMap['dining'][0] };
                }
                if (clean === 'storage') {
                    return { groupKey: 'storage', item: categoryDataMap['storage'][0] };
                }
                if (clean === 'wardrobe' || clean === 'wardrobes') {
                    return { groupKey: 'wardrobes', item: categoryDataMap['wardrobes'][0] };
                }
                if (clean === 'table' || clean === 'tables') {
                    return { groupKey: 'tables', item: categoryDataMap['tables'][0] };
                }
                if (clean === 'chair' || clean === 'chairs') {
                    return { groupKey: 'chairs', item: categoryDataMap['chairs'][0] };
                }
                if (clean === 'dressing-table' || clean === 'dressing-tables' || clean === 'dressing') {
                    var dressingItem = categoryDataMap['tables'].find(function(i) { return i.key === 'dressing-tables'; });
                    if (dressingItem) return { groupKey: 'tables', item: dressingItem };
                }

                if (categoryDataMap[clean]) {
                    return { groupKey: clean, item: categoryDataMap[clean][0] };
                }
                if (categoryDataMap[clean + 's']) {
                    return { groupKey: clean + 's', item: categoryDataMap[clean + 's'][0] };
                }

                for (var group in categoryDataMap) {
                    if (group === 'top') continue;
                    var items = categoryDataMap[group];
                    for (var i = 0; i < items.length; i++) {
                        var it = items[i];
                        var itemKey = (it.key || '').toLowerCase();
                        var itemUrl = (it.url || '').toLowerCase();
                        var itemNameClean = it.name.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');

                        if (itemKey === clean || itemNameClean === clean || itemUrl.endsWith('/' + clean)) {
                            return { groupKey: group, item: it };
                        }
                    }
                }
                return null;
            }

            /* ── Helper to detect "All" type categories / top-level department browsing ── */
            function isAllTypeCategory(catName) {
                if (!catName) return true;
                var clean = catName.toLowerCase().trim();
                return (
                    clean.startsWith('all ') ||
                    clean.startsWith('all-') ||
                    clean === 'all' ||
                    clean === 'all categories' ||
                    clean === 'all-categories' ||
                    clean === 'best sellers' ||
                    clean === 'best-sellers' ||
                    clean === 'best seller' ||
                    clean === 'best-seller' ||
                    clean === 'bestsellers' ||
                    clean === 'bestseller' ||
                    clean === 'best_sellers' ||
                    clean === 'best_seller' ||
                    clean === 'sofas' ||
                    clean === 'all sofas' ||
                    clean === 'sofas-couches' ||
                    clean === 'sofa' ||
                    clean === 'beds' ||
                    clean === 'all beds' ||
                    clean === 'bed' ||
                    clean === 'dining' ||
                    clean === 'all dining' ||
                    clean === 'wardrobes' ||
                    clean === 'all wardrobes' ||
                    clean === 'wardrobe' ||
                    clean === 'tables' ||
                    clean === 'all tables' ||
                    clean === 'table' ||
                    clean === 'chairs' ||
                    clean === 'all chairs' ||
                    clean === 'chair' ||
                    clean === 'storage' ||
                    clean === 'all storage' ||
                    clean === 'decor' ||
                    clean === 'all decor' ||
                    clean.includes('clearance') ||
                    clean.includes('sale') ||
                    clean.startsWith('results for')
                );
            }

            /* ── Specific Category vs Broad Category Keyword Identifier ── */
            function getCategorySpecificKeywords(catName) {
                if (!catName) return null;
                var clean = catName.toLowerCase().trim();

                // Broad / Top-level categories (All variants should be shown)
                if (
                    clean === 'all categories' || clean === 'all' || clean === 'best sellers' ||
                    clean === 'sofas' || clean === 'all sofas' || clean === 'sofas-couches' ||
                    clean === 'beds' || clean === 'all beds' ||
                    clean === 'dining' || clean === 'all dining' || clean === 'dining sets' ||
                    clean === 'wardrobes' || clean === 'all wardrobes' ||
                    clean === 'tables' || clean === 'all tables' ||
                    clean === 'chairs' || clean === 'all chairs' ||
                    clean === 'storage' || clean === 'all storage' ||
                    clean === 'decor' || clean === 'all decor' ||
                    clean.includes('clearance') || clean.includes('sale') ||
                    clean.startsWith('results for')
                ) {
                    return null;
                }

                // Seating Capacity Specific Categories
                if (clean.includes('2 seater') || clean.includes('two seater') || clean === '2-seater-sofas') {
                    return { type: 'capacity', keywords: ['2 seater', '2-seater', '2 seat', '2-seat', 'two seater', 'loveseat', '2s'] };
                }
                if (clean.includes('3 seater') || clean.includes('three seater') || clean === '3-seater-sofas') {
                    return { type: 'capacity', keywords: ['3 seater', '3-seater', '3 seat', '3-seat', 'three seater', '3s'] };
                }
                if (clean.includes('1 seater') || clean.includes('single seater') || clean.includes('single sofa')) {
                    return { type: 'capacity', keywords: ['1 seater', '1-seater', '1 seat', '1-seat', 'one seater', 'single', '1s', 'armchair'] };
                }
                if (clean.includes('4 seater') || clean.includes('four seater')) {
                    return { type: 'capacity', keywords: ['4 seater', '4-seater', '4 seat', '4-seat', 'four seater', '4s'] };
                }
                if (clean.includes('5 seater') || clean.includes('five seater') || clean === '5-seater-sofas') {
                    return { type: 'capacity', keywords: ['5 seater', '5-seater', '5 seat', '5-seat', 'five seater', '3+2', '3 + 2', '5s'] };
                }
                if (clean.includes('6 seater') || clean.includes('six seater') || clean === '6-seater-sofas') {
                    return { type: 'capacity', keywords: ['6 seater', '6-seater', '6 seat', '6-seat', 'six seater', '6s'] };
                }
                if (clean.includes('sectional') || clean.includes('l shape') || clean.includes('l-shape') || clean === 'sectional-sofas' || clean === 'l-shape-sofas') {
                    return { type: 'capacity', keywords: ['sectional', 'l shape', 'l-shape', 'l-shaped', 'l shaped', 'corner'] };
                }
                if (clean.includes('recliner')) {
                    return { type: 'general', keywords: ['recliner', 'recline'] };
                }
                if (clean.includes('sofa cum bed') || clean.includes('sofa bed')) {
                    return { type: 'general', keywords: ['sofa cum bed', 'sofa-cum-bed', 'sofa bed', 'sleeper'] };
                }
                if (clean.includes('velvet')) {
                    return { type: 'general', keywords: ['velvet'] };
                }
                if (clean.includes('suede')) {
                    return { type: 'general', keywords: ['suede'] };
                }
                if (clean.includes('boucle') || clean.includes('bouclé')) {
                    return { type: 'general', keywords: ['boucle', 'bouclé'] };
                }
                if (clean.includes('sofa set') || clean === 'sofa-sets' || clean === 'sofa-set') {
                    return { type: 'general', keywords: ['sofa set', 'sofa-set', 'sofas set', '3+2', '3+1+1', '3 + 2', '3 + 1 + 1', 'set'] };
                }
                if (clean.includes('leather')) {
                    return { type: 'general', keywords: ['leather', 'leatherette'] };
                }

                // Bed Specific Categories
                if (clean.includes('king size') || clean === 'king beds' || clean === 'king-size-beds') {
                    return { type: 'size', keywords: ['king size', 'king-size', 'king'] };
                }
                if (clean.includes('queen size') || clean === 'queen beds' || clean === 'queen-size-beds') {
                    return { type: 'size', keywords: ['queen size', 'queen-size', 'queen'] };
                }
                if (clean.includes('kids beds') || clean.includes('kids')) {
                    return { type: 'general', keywords: ['kids', 'kid', 'single', 'single bed'] };
                }
                if (clean.includes('storage beds') || clean.includes('storage bed')) {
                    return { type: 'general', keywords: ['storage', 'hydraulic', 'drawer'] };
                }

                // Wardrobe Specific Categories
                if (clean.includes('2 door') || clean === '2-door-wardrobe' || clean === '2-door-wardrobes') {
                    return { type: 'door', keywords: ['2 door', '2-door', '2door', 'two door'] };
                }
                if (clean.includes('3 door') || clean === '3-door-wardrobe' || clean === '3-door-wardrobes') {
                    return { type: 'door', keywords: ['3 door', '3-door', '3door', 'three door'] };
                }
                if (clean.includes('sliding')) {
                    return { type: 'general', keywords: ['sliding', 'slider'] };
                }

                // Table / Dining / Storage / Other Categories
                if (clean.includes('marble top') || clean.includes('marble')) {
                    return { type: 'general', keywords: ['marble'] };
                }
                if (clean.includes('wooden dining') || clean.includes('wooden wardrobe')) {
                    return { type: 'general', keywords: ['wooden', 'wood', 'sheesham', 'teak'] };
                }
                if (clean.includes('coffee table') || clean === 'coffee-tables') {
                    return { type: 'general', keywords: ['coffee table', 'coffee'] };
                }
                if (clean.includes('study table') || clean === 'study-tables') {
                    return { type: 'general', keywords: ['study table', 'study', 'desk'] };
                }
                if (clean.includes('side table') || clean === 'side-tables') {
                    return { type: 'general', keywords: ['side table', 'end table', 'side'] };
                }
                if (clean.includes('console') || clean === 'console-tables') {
                    return { type: 'general', keywords: ['console'] };
                }
                if (clean.includes('dressing') || clean === 'dressing-tables' || clean === 'dressing-table' || clean.includes('dresser') || clean.includes('vanity')) {
                    return { type: 'general', keywords: ['dressing table', 'dressing', 'dresser', 'vanity'] };
                }
                if (clean.includes('lounge chair') || clean === 'lounge-chairs') {
                    return { type: 'general', keywords: ['lounge', 'accent chair', 'armchair'] };
                }
                if (clean.includes('dining chair') || clean === 'dining-chairs') {
                    return { type: 'general', keywords: ['dining chair'] };
                }
                if (clean.includes('office chair') || clean === 'office-chairs') {
                    return { type: 'general', keywords: ['office chair', 'ergonomic', 'desk chair'] };
                }
                if (clean.includes('bench') || clean === 'benches') {
                    return { type: 'general', keywords: ['bench'] };
                }
                if (clean.includes('tv unit') || clean === 'tv-units') {
                    return { type: 'general', keywords: ['tv unit', 'tv console', 'tv stand', 'entertainment unit', 'tv'] };
                }
                if (clean.includes('sideboard') || clean.includes('side board') || clean === 'side-boards') {
                    return { type: 'general', keywords: ['sideboard', 'side board', 'credenza', 'buffet', 'storage'] };
                }
                if (clean.includes('chest of drawer') || clean === 'chest-of-drawers') {
                    return { type: 'general', keywords: ['chest of drawer', 'drawer', 'dresser'] };
                }
                if (clean.includes('bookshelf') || clean.includes('book shelves') || clean === 'bookshelves') {
                    return { type: 'general', keywords: ['bookshelf', 'book shelf', 'bookcase'] };
                }
                if (clean.includes('lamp') || clean.includes('lighting')) {
                    return { type: 'general', keywords: ['lamp', 'light'] };
                }
                if (clean.includes('mirror') || clean === 'mirrors') {
                    return { type: 'general', keywords: ['mirror'] };
                }

                return null;
            }

            /* ── Smart Variant-Aware Price & Context Engine ── */
            function getActiveVariantKeywords() {
                var keywords = [];

                // 1. Checkbox filters take highest precedence if checked
                var activeCapacities = Array.from(document.querySelectorAll('.filter-capacity-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });
                var activeSizes = Array.from(document.querySelectorAll('.filter-size-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });

                if (activeCapacities.length === 1) {
                    var cap = activeCapacities[0];
                    keywords.push(cap);
                    keywords.push(cap.replace(/\s+/g, '-'));
                    keywords.push(cap.replace(/\s+/g, ''));
                    if (cap === '3 seater') keywords.push('three seater', '3 seat', '3-seat', '3s');
                    if (cap === '2 seater') keywords.push('two seater', '2 seat', '2-seat', '2s', 'loveseat');
                    if (cap === '1 seater') keywords.push('one seater', '1 seat', '1-seat', '1s', 'armchair', 'single');
                    if (cap === '5 seater') keywords.push('five seater', '5 seat', '5-seat', '5s', '3+2', '3 + 2');
                    if (cap.includes('sectional') || cap.includes('l shape') || cap.includes('l-shape')) keywords.push('sectional', 'l shape', 'l-shape', 'l-shaped', 'l shaped', 'corner');
                }

                if (activeSizes.length === 1) {
                    var sz = activeSizes[0];
                    keywords.push(sz);
                    if (sz.includes('king')) keywords.push('king size', 'king-size', 'king');
                    if (sz.includes('queen')) keywords.push('queen size', 'queen-size', 'queen');
                }

                // 2. If no specific checkbox filter is active, check current category name
                if (keywords.length === 0 && currentCategoryName) {
                    var catSpecific = getCategorySpecificKeywords(currentCategoryName);
                    if (catSpecific && catSpecific.keywords) {
                        keywords = keywords.concat(catSpecific.keywords);
                    }
                }

                return keywords;
            }

            function findMatchingVariant(node, activeKeywords) {
                if (!node || !activeKeywords || activeKeywords.length === 0) return null;

                var jsonItem = node.querySelector('[data-json-product]') || node;
                var jsonStr = jsonItem ? jsonItem.getAttribute('data-json-product') : null;
                if (!jsonStr) return null;

                try {
                    var pData = typeof jsonStr === 'object' ? jsonStr : JSON.parse(jsonStr);
                    if (!pData || !pData.variants || pData.variants.length <= 1) return null;

                    for (var i = 0; i < pData.variants.length; i++) {
                        var v = pData.variants[i];
                        var vTitle = (v.title || '').toLowerCase();
                        var vOptions = (v.options || []).map(function(o) { return String(o).toLowerCase(); }).join(' ');
                        var combined = (vTitle + ' ' + vOptions).trim();

                        var matched = activeKeywords.some(function(kw) {
                            return combined.includes(kw);
                        });

                        if (matched) {
                            return { variant: v, pData: pData };
                        }
                    }
                } catch(e) {
                    return null;
                }
                return null;
            }

            function getVariantImageSrc(matchedVariant, pData, node) {
                if (!matchedVariant) return null;

                var candidate = null;

                // 0. Check data-variant-photos (Metafield photos from Shopify Admin)
                if (node) {
                    var metaItem = node.querySelector('[data-variant-photos]') || node;
                    var metaPhotosStr = metaItem ? metaItem.getAttribute('data-variant-photos') : null;
                    if (metaPhotosStr) {
                        try {
                            var metaMap = JSON.parse(metaPhotosStr);
                            if (metaMap && metaMap[matchedVariant.id] && metaMap[matchedVariant.id].trim()) {
                                candidate = metaMap[matchedVariant.id].trim();
                            }
                        } catch(e) {}
                    }
                }

                if (candidate && !candidate.includes('no-image') && !candidate.includes('no_image') && !candidate.includes('placeholder')) {
                    return candidate;
                }

                // 1. featured_image object / string
                if (matchedVariant.featured_image) {
                    if (typeof matchedVariant.featured_image === 'string' && matchedVariant.featured_image) candidate = matchedVariant.featured_image;
                    else if (matchedVariant.featured_image.src) candidate = matchedVariant.featured_image.src;
                }

                if (candidate && !candidate.includes('no-image') && !candidate.includes('no_image') && !candidate.includes('placeholder')) {
                    return candidate;
                }

                // 2. featured_media preview_image
                if (matchedVariant.featured_media && matchedVariant.featured_media.preview_image && matchedVariant.featured_media.preview_image.src) {
                    candidate = matchedVariant.featured_media.preview_image.src;
                }

                if (candidate && !candidate.includes('no-image') && !candidate.includes('no_image') && !candidate.includes('placeholder')) {
                    return candidate;
                }

                // 3. direct image string / object
                if (matchedVariant.image) {
                    if (typeof matchedVariant.image === 'string') candidate = matchedVariant.image;
                    else if (matchedVariant.image.src) candidate = matchedVariant.image.src;
                }

                if (candidate && !candidate.includes('no-image') && !candidate.includes('no_image') && !candidate.includes('placeholder')) {
                    return candidate;
                }

                // 4. lookup image_id in pData.media
                var imgId = matchedVariant.image_id || (matchedVariant.featured_image && matchedVariant.featured_image.id);
                if (imgId && pData && pData.media && Array.isArray(pData.media)) {
                    var foundMedia = pData.media.find(function(m) { return m.id === imgId; });
                    if (foundMedia && foundMedia.src) candidate = foundMedia.src;
                }

                if (candidate && !candidate.includes('no-image') && !candidate.includes('no_image') && !candidate.includes('placeholder')) {
                    return candidate;
                }

                return null;
            }

            function formatPriceRs(amountInRupees) {
                return 'Rs. ' + Math.round(amountInRupees).toLocaleString('en-IN');
            }

            function syncCardVariantDisplay(node, matchResult) {
                if (!node) return;

                var cardPriceWrap = node.querySelector('.card-price, .price-box, .price');
                if (!cardPriceWrap) return;

                if (!node.hasAttribute('data-original-price-html')) {
                    node.setAttribute('data-original-price-html', cardPriceWrap.innerHTML);
                }

                var matchedVariant = matchResult ? (matchResult.variant || matchResult) : null;
                var pData = matchResult ? matchResult.pData : null;

                if (matchedVariant) {
                    var rawPrice = Number(matchedVariant.price);
                    if (rawPrice >= 100000) {
                        rawPrice = rawPrice / 100;
                    }
                    var rawCompare = matchedVariant.compare_at_price ? Number(matchedVariant.compare_at_price) : null;
                    if (rawCompare && rawCompare >= 100000) {
                        rawCompare = rawCompare / 100;
                    }

                    node.setAttribute('data-active-variant-price', rawPrice);

                    var formattedPrice = formatPriceRs(rawPrice);
                    var formattedCompare = rawCompare && rawCompare > rawPrice ? formatPriceRs(rawCompare) : null;
                    var discountPercent = rawCompare && rawCompare > rawPrice ? Math.round(((rawCompare - rawPrice) / rawCompare) * 100) : 0;

                    var newPriceHtml = '<div class="price' + (formattedCompare ? ' price--on-sale' : '') + '"><dl><div class="' + (formattedCompare ? 'price__sale' : 'price__regular') + '">';
                    newPriceHtml += '<dd class="price__last"><span class="price-item ' + (formattedCompare ? 'price-item--sale' : 'price-item--regular') + '" style="font-weight:700;">' + formattedPrice + '</span></dd>';
                    if (formattedCompare) {
                        newPriceHtml += '<dd class="price__compare"><s class="price-item price-item--regular" style="color:#999; margin-left:6px; font-size:12px;">' + formattedCompare + '</s></dd>';
                    }
                    if (discountPercent > 0) {
                        newPriceHtml += '<dd class="price__label_sale" style="margin:0; display:inline-block; vertical-align:middle;">' +
                            '<span class="label_sale" style="display:inline-block; background:#b22222; color:#fff; font-weight:700; font-size:11px; padding:2px 6px; border-radius:4px; margin-left:6px; vertical-align:middle;">-' + discountPercent + '%</span></dd>';
                    }
                    newPriceHtml += '</div></dl></div>';

                    cardPriceWrap.innerHTML = newPriceHtml;

                    // Update EMI if present
                    var emiEl = node.querySelector('.card-emi, .product-emi, [data-emi-price]');
                    if (emiEl) {
                        var emiPerMonth = Math.round(rawPrice / 6);
                        emiEl.textContent = 'Or ' + formatPriceRs(emiPerMonth) + '/mo';
                    }

                    // 1. Direct variant link update
                    if (matchedVariant.id) {
                        var links = node.querySelectorAll('a[href*="/products/"]');
                        links.forEach(function(link) {
                            var currentHref = link.getAttribute('href');
                            if (currentHref) {
                                var baseHref = currentHref.split('?')[0].split('#')[0];
                                link.setAttribute('href', baseHref + '?variant=' + matchedVariant.id);
                            }
                        });
                    }

                    // 2. Variant specific photo update (if assigned in Shopify Admin or Metafield)
                    var vImgSrc = getVariantImageSrc(matchedVariant, pData, node);
                    var cardImg = node.querySelector('.card-media img:not(.icon), .card-product img:not(.icon)');
                    if (cardImg) {
                        if (!cardImg.hasAttribute('data-original-src')) {
                            cardImg.setAttribute('data-original-src', cardImg.getAttribute('src') || cardImg.getAttribute('data-src') || '');
                            if (cardImg.getAttribute('srcset') || cardImg.getAttribute('data-srcset')) {
                                cardImg.setAttribute('data-original-srcset', cardImg.getAttribute('srcset') || cardImg.getAttribute('data-srcset') || '');
                            }
                        }
                        if (vImgSrc && !vImgSrc.includes('no-image') && !vImgSrc.includes('no_image')) {
                            if (vImgSrc.startsWith('//')) vImgSrc = 'https:' + vImgSrc;
                            cardImg.setAttribute('src', vImgSrc);
                            cardImg.setAttribute('data-src', vImgSrc);
                            cardImg.setAttribute('srcset', vImgSrc);
                            cardImg.setAttribute('data-srcset', vImgSrc);
                            cardImg.classList.remove('lazyload');
                            cardImg.classList.add('lazyloaded');
                        } else if (cardImg.hasAttribute('data-original-src')) {
                            // Revert to original product image if variant has no specific image
                            var oSrc = cardImg.getAttribute('data-original-src');
                            if (oSrc) {
                                cardImg.setAttribute('src', oSrc);
                                cardImg.setAttribute('data-src', oSrc);
                            }
                            var oSrcset = cardImg.getAttribute('data-original-srcset');
                            if (oSrcset) {
                                cardImg.setAttribute('srcset', oSrcset);
                                cardImg.setAttribute('data-srcset', oSrcset);
                            }
                        }
                    }

                    // 3. Title suffix and Swatch active state update
                    var titleEl = node.querySelector('.card-title, .card__heading a, .product-title');
                    var titleChangeSpan = titleEl ? titleEl.querySelector('[data-change-title]') : node.querySelector('.card-information [data-change-title], .card-title [data-change-title], [data-change-title]');
                    var optName = node.getAttribute('data-variant-option-name');
                    if (!titleChangeSpan && titleEl && (optName || matchedVariant)) {
                        titleChangeSpan = document.createElement('span');
                        titleChangeSpan.setAttribute('data-change-title', '');
                        titleEl.appendChild(titleChangeSpan);
                    }
                    if (titleChangeSpan) {
                        if (!titleChangeSpan.hasAttribute('data-original-title-change')) {
                            titleChangeSpan.setAttribute('data-original-title-change', titleChangeSpan.textContent);
                        }
                        if (optName) {
                            titleChangeSpan.textContent = ' - ' + optName;
                        } else {
                            var variantColor = '';
                            if (matchedVariant.options && matchedVariant.options.length > 1) {
                                variantColor = matchedVariant.options[1];
                            } else if (matchedVariant.option2) {
                                variantColor = matchedVariant.option2;
                            } else if (matchedVariant.title && matchedVariant.title.includes('/')) {
                                variantColor = matchedVariant.title.split('/')[1].trim();
                            }

                            if (variantColor) {
                                titleChangeSpan.textContent = ' - ' + variantColor;
                            }
                        }
                    }

                    // Swatch active state update
                    var currentVariantColor = (matchedVariant.option2 || (matchedVariant.title && matchedVariant.title.includes('/') ? matchedVariant.title.split('/')[1] : '')).toLowerCase().trim();
                    if (currentVariantColor) {
                        var swatches = node.querySelectorAll('.swatch-label');
                        swatches.forEach(function(sw) {
                            var swVal = (sw.getAttribute('data-value') || sw.getAttribute('title') || '').toLowerCase().trim();
                            if (swVal === currentVariantColor || swVal === currentVariantColor.replace(/\s+/g, '-') || swVal === currentVariantColor.replace(/-/g, ' ')) {
                                sw.classList.add('is-active');
                            } else {
                                sw.classList.remove('is-active');
                            }
                        });
                    }
                } else {
                    node.removeAttribute('data-active-variant-price');
                    var originalHtml = node.getAttribute('data-original-price-html');
                    if (originalHtml) {
                        cardPriceWrap.innerHTML = originalHtml;
                    }

                    // Restore original card title suffix
                    var titleChangeSpanReset = node.querySelector('.card-information [data-change-title], .card-title [data-change-title], [data-change-title]');
                    if (titleChangeSpanReset && titleChangeSpanReset.hasAttribute('data-original-title-change')) {
                        titleChangeSpanReset.textContent = titleChangeSpanReset.getAttribute('data-original-title-change');
                        titleChangeSpanReset.removeAttribute('data-original-title-change');
                    }

                    // Restore original card image
                    var cardImgReset = node.querySelector('.card-media img:not(.icon), .card-product img:not(.icon)');
                    if (cardImgReset && cardImgReset.hasAttribute('data-original-src')) {
                        var origSrc = cardImgReset.getAttribute('data-original-src');
                        if (origSrc) {
                            cardImgReset.setAttribute('src', origSrc);
                            cardImgReset.setAttribute('data-src', origSrc);
                        }
                        var origSrcset = cardImgReset.getAttribute('data-original-srcset');
                        if (origSrcset) {
                            cardImgReset.setAttribute('srcset', origSrcset);
                            cardImgReset.setAttribute('data-srcset', origSrcset);
                        }
                        cardImgReset.removeAttribute('data-original-src');
                        cardImgReset.removeAttribute('data-original-srcset');
                    }
                }
            }

            function getProductPrice(node) {
                // Priority 1: If active variant price is resolved dynamically
                if (node.hasAttribute('data-active-variant-price')) {
                    var vPrice = parseFloat(node.getAttribute('data-active-variant-price'));
                    if (!isNaN(vPrice) && vPrice > 0) return vPrice;
                }

                // 1. If product has on-sale price item, extract only from that active price
                var saleEl = node.querySelector('.price--on-sale .price-item--sale, .price-item--sale, .price__sale .price-item--last');
                if (saleEl) {
                    var matchSale = saleEl.textContent.match(/([0-9]+(?:,[0-9]+)*(?:\.[0-9]+)?)/);
                    if (matchSale) {
                        var valSale = parseFloat(matchSale[1].replace(/,/g, ''));
                        if (!isNaN(valSale) && valSale > 0) return valSale;
                    }
                }

                // 2. If product is regular (not on sale), extract from regular price item
                var regEl = node.querySelector('.price__regular .price-item--regular, .price:not(.price--on-sale) .price-item--regular, .price-item--regular');
                if (regEl) {
                    var matchReg = regEl.textContent.match(/([0-9]+(?:,[0-9]+)*(?:\.[0-9]+)?)/);
                    if (matchReg) {
                        var valReg = parseFloat(matchReg[1].replace(/,/g, ''));
                        if (!isNaN(valReg) && valReg > 0) return valReg;
                    }
                }

                // 3. Fallback: Parse from clean price container without EMI or compare price
                var priceContainer = node.querySelector('.price');
                if (priceContainer) {
                    var clone = priceContainer.cloneNode(true);
                    var extraElements = clone.querySelectorAll('s, .tt-emi-card, .price__compare, .unit-price');
                    extraElements.forEach(function(el) { el.remove(); });
                    var match = clone.textContent.match(/(?:₹|Rs\.?)\s*([0-9,]+)/i);
                    if (match) {
                        var valFallback = parseFloat(match[1].replace(/,/g, ''));
                        if (!isNaN(valFallback) && valFallback > 0) return valFallback;
                    }
                }

                return 0;
            }

            function getProductTitle(node) {
                if (!node) return '';
                var tEl = node.querySelector('.card-title, [data-product-title], .product-title, .card__heading a, h3 a');
                if (tEl) {
                    var attrTitle = tEl.getAttribute('data-product-title');
                    if (attrTitle && attrTitle.trim()) return attrTitle.trim().toLowerCase();
                    var txt = tEl.textContent.trim().toLowerCase();
                    if (txt) return txt;
                }
                var anyLink = node.querySelector('a[href*="/products/"]');
                if (anyLink) {
                    var href = anyLink.getAttribute('href') || '';
                    var handle = href.split('/products/')[1];
                    if (handle) return handle.split('?')[0].split('#')[0].replace(/-/g, ' ').toLowerCase();
                }
                return (node.textContent || '').trim().toLowerCase();
            }

            /* ── Helper to detect Product Category from Title & Links ── */
            function getProductCategory(node) {
                if (!node) return 'general';
                var title = getProductTitle(node).toLowerCase();
                var href = '';
                var a = node.querySelector('a[href*="/products/"]');
                if (a) href = (a.getAttribute('href') || '').toLowerCase();
                var combined = (title + ' ' + href).trim();

                // 1. Sofa Cum Bed / Sofa Bed
                if (combined.includes('sofa cum bed') || combined.includes('sofa-cum-bed') || combined.includes('sofa bed')) {
                    return 'sofas';
                }

                // 2. Sofas & Couches
                if (
                    combined.includes('sofa') || combined.includes('couch') || combined.includes('sectional') ||
                    combined.includes('recliner') || combined.includes('loveseat') || combined.includes('chesterfield')
                ) {
                    return 'sofas';
                }

                // 3. Beds
                if (combined.includes('bed') || combined.includes('mattress') || combined.includes('headboard') || combined.includes('nightstand')) {
                    return 'beds';
                }

                // 4. Dining
                if (combined.includes('dining')) {
                    return 'dining';
                }

                // 5. Wardrobes
                if (combined.includes('wardrobe') || combined.includes('almirah') || combined.includes('closet')) {
                    return 'wardrobes';
                }

                // 6. Tables (Coffee, Study, Side, Console, Desk)
                if (combined.includes('table') || combined.includes('desk')) {
                    return 'tables';
                }

                // 7. Chairs & Benches
                if (combined.includes('chair') || combined.includes('bench') || combined.includes('stool') || combined.includes('ottoman')) {
                    return 'chairs';
                }

                // 8. Storage (TV Units, Sideboards, Bookshelves, Drawers)
                if (
                    combined.includes('tv unit') || combined.includes('tv console') || combined.includes('tv stand') ||
                    combined.includes('sideboard') || combined.includes('side board') || combined.includes('bookshelf') ||
                    combined.includes('book shelf') || combined.includes('bookcase') || combined.includes('drawer') ||
                    combined.includes('chest') || combined.includes('storage')
                ) {
                    return 'storage';
                }

                // 9. Decor & Lighting
                if (combined.includes('lamp') || combined.includes('lighting') || combined.includes('light') || combined.includes('mirror') || combined.includes('decor')) {
                    return 'decor';
                }

                return 'general';
            }

            /* ── Helper to detect Best Seller search intent ── */
            function isBestSellerQuery(str) {
                if (!str) return false;
                var clean = str.toLowerCase().trim()
                    .replace(/^results for ["']?/i, '')
                    .replace(/["']?$/i, '')
                    .trim();
                if (!clean) return false;

                if (
                    clean === 'best sellers' ||
                    clean === 'best seller' ||
                    clean === 'bestseller' ||
                    clean === 'bestsellers' ||
                    clean === 'best-seller' ||
                    clean === 'best-sellers' ||
                    clean === 'best_seller' ||
                    clean === 'best_sellers' ||
                    clean === 'best selling' ||
                    clean === 'best-selling' ||
                    clean === 'bestselling' ||
                    clean === 'top seller' ||
                    clean === 'top-seller' ||
                    clean === 'topseller' ||
                    clean === 'top sellers'
                ) {
                    return true;
                }

                if (
                    clean.includes('best seller') ||
                    clean.includes('best-seller') ||
                    clean.includes('best_seller') ||
                    clean.includes('bestseller') ||
                    clean.includes('best selling') ||
                    clean.includes('best-selling') ||
                    clean.includes('bestselling') ||
                    clean.includes('top seller') ||
                    clean.includes('top-seller')
                ) {
                    return true;
                }

                return false;
            }

            /* ── Helper to extract all product tags cleanly ── */
            function getProductTags(node) {
                if (!node) return [];
                var tags = [];

                // 1. Check data-tags on node or nested elements
                var tagsAttr = node.getAttribute('data-tags');
                if (!tagsAttr) {
                    var tagEl = node.querySelector('[data-tags]');
                    if (tagEl) tagsAttr = tagEl.getAttribute('data-tags');
                }
                if (tagsAttr) {
                    tagsAttr.toLowerCase().split(',').forEach(function(t) {
                        var trimmed = t.trim();
                        if (trimmed && !tags.includes(trimmed)) tags.push(trimmed);
                    });
                }

                // 2. Check data-json-product
                var jsonItem = node.querySelector('[data-json-product]') || node;
                var jsonStr = jsonItem ? jsonItem.getAttribute('data-json-product') : null;
                if (jsonStr) {
                    try {
                        var pData = typeof jsonStr === 'object' ? jsonStr : JSON.parse(jsonStr);
                        if (pData && pData.tags) {
                            var pTags = Array.isArray(pData.tags) ? pData.tags : String(pData.tags).split(',');
                            pTags.forEach(function(t) {
                                var trimmed = String(t).toLowerCase().trim();
                                if (trimmed && !tags.includes(trimmed)) tags.push(trimmed);
                            });
                        }
                    } catch(e) {}
                }

                return tags;
            }

            /* ── Helper to determine if a product node has Best Seller tag ── */
            function isBestSellerProduct(node) {
                if (!node) return false;
                var tags = getProductTags(node);
                var hasBestSellerTag = tags.some(function(t) {
                    return (
                        t === 'best seller' ||
                        t === 'bestseller' ||
                        t === 'best-seller' ||
                        t === 'best_seller' ||
                        t === 'best sellers' ||
                        t === 'bestsellers' ||
                        t === 'best-sellers' ||
                        t === 'best_sellers' ||
                        t === 'best selling' ||
                        t === 'best-selling' ||
                        t === 'bestselling' ||
                        t === 'top seller' ||
                        t === 'top-seller' ||
                        t === 'topseller' ||
                        t === 'top sellers' ||
                        t.includes('best seller') ||
                        t.includes('bestseller') ||
                        t.includes('best-seller') ||
                        t.includes('best_seller') ||
                        t.includes('bestselling') ||
                        t.includes('best-selling') ||
                        t.includes('top seller') ||
                        t.includes('top-seller')
                    );
                });
                if (hasBestSellerTag) return true;

                // Check for rendered badge or custom badge in DOM
                var badgeEls = node.querySelectorAll('.badge, .card__badge, .halo-productBadges, .custom-badge, .product-badge, .badge-item, .product-category-badge');
                for (var b = 0; b < badgeEls.length; b++) {
                    var bTxt = badgeEls[b].textContent.toLowerCase();
                    if (
                        bTxt.includes('best seller') ||
                        bTxt.includes('bestseller') ||
                        bTxt.includes('best-seller') ||
                        bTxt.includes('top seller')
                    ) {
                        return true;
                    }
                }

                // 4. Check data attributes like data-badge, data-label, or product classes
                var nodeClass = (node.className || '').toLowerCase();
                if (
                    nodeClass.includes('bestseller') ||
                    nodeClass.includes('best-seller') ||
                    nodeClass.includes('best_seller')
                ) {
                    return true;
                }

                return false;
            }

            /* ── Helper to detect Category Intent from Search Query or Category Name ── */
            function extractCategoryIntent(nameOrQuery) {
                if (!nameOrQuery) return null;
                var clean = nameOrQuery.toLowerCase().trim()
                    .replace(/^results for ["']?/i, '')
                    .replace(/["']?$/i, '')
                    .trim();

                if (
                    !clean ||
                    clean === 'all categories' || clean === 'all' ||
                    clean === 'best sellers' || clean === 'best seller' ||
                    clean === 'bestsellers' || clean === 'bestseller' ||
                    clean === 'best-sellers' || clean === 'best-seller'
                ) {
                    return null;
                }

                // Sofa intent
                if (
                    clean.includes('sofa') || clean.includes('couch') || clean.includes('sectional') ||
                    clean.includes('recliner') || clean.includes('loveseat')
                ) {
                    return 'sofas';
                }

                // Bed intent (excluding when sofa is also mentioned e.g. "sofa bed")
                if (clean.includes('bed') && !clean.includes('sofa')) {
                    return 'beds';
                }

                // Dining intent
                if (clean.includes('dining')) {
                    return 'dining';
                }

                // Wardrobe intent
                if (clean.includes('wardrobe') || clean.includes('almirah') || clean.includes('closet')) {
                    return 'wardrobes';
                }

                // Table intent (excluding dining table)
                if (clean.includes('table') || clean.includes('desk')) {
                    return 'tables';
                }

                // Chair intent (excluding dining chair)
                if (clean.includes('chair') || clean.includes('bench') || clean.includes('stool')) {
                    return 'chairs';
                }

                // Storage intent
                if (
                    clean.includes('tv unit') || clean.includes('tv console') || clean.includes('sideboard') ||
                    clean.includes('bookshelf') || clean.includes('chest of drawer') || clean.includes('storage')
                ) {
                    return 'storage';
                }

                // Decor intent
                if (clean.includes('lamp') || clean.includes('lighting') || clean.includes('mirror') || clean.includes('decor')) {
                    return 'decor';
                }

                return null;
            }

            /* ── Helper to extract specific model / non-generic query keywords (e.g. "adina") ── */
            function extractSpecificQueryKeywords(queryStr) {
                if (!queryStr) return [];
                var cleanQ = queryStr.toLowerCase().replace(/^results for ["']?/i, '').replace(/["']?$/i, '').trim();
                if (!cleanQ) return [];

                var stopWords = [
                    'best', 'seller', 'sellers', 'bestseller', 'bestsellers',
                    'sofa', 'sofas', 'couch', 'couches', 'sectional', 'recliners', 'recliner', 'loveseat',
                    'bed', 'beds', 'king', 'queen', 'single',
                    'dining', 'table', 'tables', 'chair', 'chairs', 'bench', 'benches',
                    'wardrobe', 'wardrobes', 'storage', 'tv', 'unit', 'bookshelf', 'sideboard',
                    'furniture', 'set', 'sets', 'in', 'and', 'the', 'for', 'of', 'with', 'all', 'by', 'at'
                ];

                var words = cleanQ.split(/\s+/).map(function(w) {
                    return w.replace(/[^a-z0-9]/g, '').trim();
                }).filter(function(w) {
                    return w.length >= 2 && !stopWords.includes(w);
                });

                return words;
            }

            /* ── Helper to compute Search Query Relevance Score ── */
            function getProductRelevanceScore(node, queryStr) {
                if (!queryStr) return 0;
                var cleanQ = queryStr.toLowerCase().replace(/^results for ["']?/i, '').replace(/["']?$/i, '').trim();
                if (!cleanQ) return 0;

                var title = getProductTitle(node).toLowerCase();
                var anyLink = node.querySelector('a[href*="/products/"]');
                var href = anyLink ? (anyLink.getAttribute('href') || '').toLowerCase() : '';
                var fullCombined = (title + ' ' + href).trim();

                var words = cleanQ.split(/\s+/).filter(function(w) { return w.length > 1; });
                if (words.length === 0) return 0;

                var matchedWordsCount = 0;
                var exactFullMatch = fullCombined.includes(cleanQ);

                words.forEach(function(w) {
                    if (fullCombined.includes(w)) {
                        matchedWordsCount++;
                    }
                });

                var score = 0;
                if (exactFullMatch) score += 200;
                score += (matchedWordsCount / words.length) * 100;

                // Major score boost for specific unique query words (e.g. "adina")
                var specificWords = extractSpecificQueryKeywords(cleanQ);
                if (specificWords.length > 0) {
                    var specificMatches = specificWords.filter(function(sw) { return fullCombined.includes(sw); });
                    score += (specificMatches.length / specificWords.length) * 500;
                }

                return score;
            }

            /* ── Render Shimmer Skeleton in Grid (9 Cards with Sheen Wave) ── */
            function renderShimmerSkeleton() {
                if (!productGrid) return;
                var count = getPageSize();
                var html = '';
                for (var i = 0; i < count; i++) {
                    html += '<li class="product search-skeleton-item">' +
                        '<div class="search-skeleton-card">' +
                            '<div class="search-skeleton-image"></div>' +
                            '<div class="search-skeleton-title"></div>' +
                            '<div class="search-skeleton-subtitle"></div>' +
                            '<div class="search-skeleton-price"></div>' +
                            '<div class="search-skeleton-emi"></div>' +
                        '</div>' +
                    '</li>';
                }
                productGrid.innerHTML = html;
                productGrid.style.opacity = '1';

                var paginationWrap = document.getElementById('search-pagination-wrap');
                if (paginationWrap) paginationWrap.style.display = 'none';
            }

            /* ── Render Current Page (Sliced to exactly 3 rows) ── */
            function renderCurrentPage() {
                if (!productGrid) return;
                var pageSize = getPageSize();
                var totalItems = currentFilteredProducts.length;
                var totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

                if (currentPage > totalPages) currentPage = totalPages;
                if (currentPage < 1) currentPage = 1;

                var startIndex = (currentPage - 1) * pageSize;
                var endIndex = Math.min(startIndex + pageSize, totalItems);
                var pageItems = currentFilteredProducts.slice(startIndex, endIndex);

                productGrid.innerHTML = '';
                if (pageItems.length > 0) {
                    pageItems.forEach(function(el) {
                        el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'scroll-trigger--offscreen');
                        el.style.opacity = '1';
                        el.style.visibility = 'visible';
                        el.style.transform = 'none';
                        el.style.display = 'flex';

                        // Ensure all images are loaded eagerly and immediately decoded
                        var imgs = el.querySelectorAll('img');
                        imgs.forEach(function(img) {
                            var dSrc = img.getAttribute('data-src') || img.getAttribute('data-original');
                            if (dSrc && !img.getAttribute('src')) {
                                img.setAttribute('src', dSrc);
                            }
                            var dSrcset = img.getAttribute('data-srcset');
                            if (dSrcset && !img.getAttribute('srcset')) {
                                img.setAttribute('srcset', dSrcset);
                            }
                            img.setAttribute('loading', 'eager');
                            img.setAttribute('decoding', 'async');
                            if (img.classList.contains('lazyload')) {
                                img.classList.remove('lazyload');
                                img.classList.add('lazyloaded');
                            }
                        });
                        productGrid.appendChild(el);
                    });
                } else if (!isFetching) {
                    productGrid.innerHTML = renderNoProductsHtml('No products match your current selection or category.');
                    bindBrowseAllButton();
                }

                renderPaginationUI(totalItems, totalPages, startIndex, endIndex);
                productGrid.style.opacity = '1';
            }

            function renderNoProductsHtml(message) {
                return '<li class="search-no-products-item">' +
                    '<div class="search-no-products-card">' +
                        '<div class="no-products-icon-wrap">' +
                            '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
                                '<circle cx="11" cy="11" r="8"></circle>' +
                                '<line x1="21" y1="21" x2="16.65" y2="16.65"></line>' +
                                '<line x1="8" y1="11" x2="14" y2="11"></line>' +
                            '</svg>' +
                        '</div>' +
                        '<h3>No Products Found</h3>' +
                        '<p>' + (message || 'There are currently no products available in this category.') + '</p>' +
                        '<button type="button" class="btn-browse-all-products" id="btn-browse-all-empty-state">' +
                            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>' +
                            'Browse All Products' +
                        '</button>' +
                    '</div>' +
                '</li>';
            }

            function bindBrowseAllButton() {
                var btn = document.getElementById('btn-browse-all-empty-state');
                if (!btn) return;
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    var allCheckboxes = document.querySelectorAll('.filter-capacity-checkbox, .filter-size-checkbox, .filter-fabric-checkbox, .filter-material-checkbox, .filter-feature-checkbox, .filter-price-checkbox');
                    allCheckboxes.forEach(function(cb) { cb.checked = false; });
                    var shapePills = document.querySelectorAll('.shape-pill');
                    shapePills.forEach(function(pill) {
                        pill.classList.remove('is-active');
                        pill.style.borderColor = '#e2ddd5';
                        pill.style.background = '#ffffff';
                        pill.style.color = '#444444';
                    });
                    var colorSwatches = document.querySelectorAll('.color-swatch-btn');
                    colorSwatches.forEach(function(swatch) {
                        swatch.classList.remove('is-active');
                        swatch.style.outline = 'none';
                    });

                    if (window.history && window.history.pushState) {
                        window.history.pushState(null, '', '/search?category=all');
                    }
                    renderSidebar('top', '/collections/all');
                    loadProducts('All Categories', '/collections/all');
                });
            }

            /* ── Render Luxury Pagination UI with Prev, Numbers, Ellipsis, Next & Showing Info ── */
            function renderPaginationUI(totalItems, totalPages, startIndex, endIndex) {
                var paginationWrap = document.getElementById('search-pagination-wrap');
                var paginationInfo = document.getElementById('search-pagination-info');
                var paginationList = document.getElementById('search-pagination-list');
                if (!paginationWrap || !paginationInfo || !paginationList) return;

                if (totalItems <= 0) {
                    paginationWrap.style.display = 'none';
                    return;
                }

                paginationWrap.style.display = 'flex';
                paginationInfo.textContent = 'Showing ' + (startIndex + 1) + '–' + endIndex + ' of ' + totalItems + ' products';

                if (totalPages <= 1) {
                    paginationList.innerHTML = '';
                    return;
                }

                var html = '';

                // Previous Button
                var prevDisabled = currentPage === 1;
                html += '<li><button type="button" class="search-page-btn prev-btn' + (prevDisabled ? ' is-disabled' : '') + '" data-page="' + (currentPage - 1) + '" ' + (prevDisabled ? 'disabled' : '') + ' aria-label="Previous Page">‹ Prev</button></li>';

                function addPageBtn(p) {
                    var isActive = p === currentPage;
                    html += '<li><button type="button" class="search-page-btn' + (isActive ? ' is-active' : '') + '" data-page="' + p + '" aria-label="Page ' + p + '" ' + (isActive ? 'aria-current="page"' : '') + '>' + p + '</button></li>';
                }

                function addEllipsis() {
                    html += '<li><span class="search-page-ellipsis">…</span></li>';
                }

                var isMobile = window.innerWidth <= 600;

                if (isMobile) {
                    if (totalPages <= 4) {
                        for (var p = 1; p <= totalPages; p++) {
                            addPageBtn(p);
                        }
                    } else if (currentPage <= 2) {
                        addPageBtn(1);
                        addPageBtn(2);
                        if (totalPages > 3) {
                            addEllipsis();
                        }
                        addPageBtn(totalPages);
                    } else if (currentPage >= totalPages - 1) {
                        addPageBtn(1);
                        if (totalPages > 3) {
                            addEllipsis();
                        }
                        addPageBtn(totalPages - 1);
                        addPageBtn(totalPages);
                    } else {
                        addPageBtn(1);
                        if (currentPage > 2) {
                            addEllipsis();
                        }
                        addPageBtn(currentPage);
                        if (currentPage < totalPages - 1) {
                            addEllipsis();
                        }
                        addPageBtn(totalPages);
                    }
                } else {
                    if (totalPages <= 7) {
                        for (var p = 1; p <= totalPages; p++) {
                            addPageBtn(p);
                        }
                    } else {
                        addPageBtn(1);
                        if (currentPage > 3) {
                            addEllipsis();
                        }

                        var start = Math.max(2, currentPage - 1);
                        var end = Math.min(totalPages - 1, currentPage + 1);

                        for (var i = start; i <= end; i++) {
                            addPageBtn(i);
                        }

                        if (currentPage < totalPages - 2) {
                            addEllipsis();
                        }
                        addPageBtn(totalPages);
                    }
                }

                // Next Button
                var nextDisabled = currentPage === totalPages;
                html += '<li><button type="button" class="search-page-btn next-btn' + (nextDisabled ? ' is-disabled' : '') + '" data-page="' + (currentPage + 1) + '" ' + (nextDisabled ? 'disabled' : '') + ' aria-label="Next Page">Next ›</button></li>';

                paginationList.innerHTML = html;

                var btns = paginationList.querySelectorAll('.search-page-btn:not(:disabled)');
                btns.forEach(function(btn) {
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        var targetPage = parseInt(this.getAttribute('data-page'), 10);
                        if (!isNaN(targetPage) && targetPage >= 1 && targetPage <= totalPages && targetPage !== currentPage) {
                            currentPage = targetPage;
                            renderCurrentPage();
                            var scrollAnchor = document.querySelector('.search-main-toolbar') || productGrid;
                            if (scrollAnchor) {
                                scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                        }
                    });
                });
            }

            function applyFiltersAndSort(resetPage) {
                if (resetPage) {
                    currentPage = 1;
                }

                if (!rawLoadedProducts || rawLoadedProducts.length === 0) {
                    currentFilteredProducts = [];
                    renderCurrentPage();
                    return;
                }

                // 1. Sync Active Variant Price & Card Display for unexpanded loaded products
                var activeVariantKeywords = getActiveVariantKeywords();
                rawLoadedProducts.forEach(function(node) {
                    if (!node.hasAttribute('data-variant-expanded-id')) {
                        var matched = findMatchingVariant(node, activeVariantKeywords);
                        syncCardVariantDisplay(node, matched);
                    }
                });

                var activeCapacities = Array.from(document.querySelectorAll('.filter-capacity-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });
                var activeShapes     = Array.from(document.querySelectorAll('.shape-pill.is-active')).map(function(btn) { return btn.getAttribute('data-shape').toLowerCase().trim(); });
                var activeSizes      = Array.from(document.querySelectorAll('.filter-size-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });
                var activeDoors      = Array.from(document.querySelectorAll('.filter-door-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });
                var activeFabrics    = Array.from(document.querySelectorAll('.filter-fabric-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });
                var activeColors     = Array.from(document.querySelectorAll('.color-swatch-btn.is-active')).map(function(btn) { return btn.getAttribute('data-color').toLowerCase().trim(); });
                var activeMaterials  = Array.from(document.querySelectorAll('.filter-material-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });
                var activeFeatures   = Array.from(document.querySelectorAll('.filter-feature-checkbox:checked')).map(function(cb) { return cb.value.toLowerCase().trim(); });
                var activePrices     = Array.from(document.querySelectorAll('.filter-price-checkbox:checked')).map(function(cb) { return cb.value; });

                var catFilterInfo    = getCategorySpecificKeywords(currentCategoryName);

                // Category Intent Detection: Exclude conflicting categories (e.g. Bed when searching for Sofa)
                var searchInputVal = searchLandingInput ? searchLandingInput.value.trim() : '';
                var activeSearchQuery = currentSearchQuery || searchInputVal || (new URLSearchParams(window.location.search).get('q') || '');
                var detectedCategoryIntent = extractCategoryIntent(currentCategoryName) || extractCategoryIntent(activeSearchQuery);
                var isBestSellerMode = isBestSellerQuery(currentCategoryName) || isBestSellerQuery(activeSearchQuery);

                // Specific Search Keyword Detection (e.g. "adina" in "adina sofa")
                var specificQueryKeywords = extractSpecificQueryKeywords(activeSearchQuery);
                var hasMatchingSpecificProducts = false;
                if (specificQueryKeywords.length > 0) {
                    hasMatchingSpecificProducts = rawLoadedProducts.some(function(node) {
                        var title = getProductTitle(node);
                        var anyLink = node.querySelector('a[href*="/products/"]');
                        var href = anyLink ? (anyLink.getAttribute('href') || '').toLowerCase() : '';
                        var varOptName = (node.getAttribute('data-variant-option-name') || '').toLowerCase();
                        var full = (title + ' ' + href + ' ' + varOptName);
                        return specificQueryKeywords.every(function(kw) {
                            return full.includes(kw);
                        });
                    });
                }

                var hasActiveFilters = (
                    activeCapacities.length > 0 ||
                    activeShapes.length > 0 ||
                    activeSizes.length > 0 ||
                    activeDoors.length > 0 ||
                    activeFabrics.length > 0 ||
                    activeColors.length > 0 ||
                    activeMaterials.length > 0 ||
                    activeFeatures.length > 0 ||
                    activePrices.length > 0
                );

                var totalActiveFiltersCount = activeCapacities.length + activeShapes.length + activeSizes.length + activeDoors.length + activeFabrics.length + activeColors.length + activeMaterials.length + activeFeatures.length + activePrices.length;
                var mobileFilterBadge = document.getElementById('mobile-filter-count-badge');
                if (mobileFilterBadge) {
                    if (totalActiveFiltersCount > 0) {
                        mobileFilterBadge.textContent = totalActiveFiltersCount;
                        mobileFilterBadge.style.display = 'inline-flex';
                    } else {
                        mobileFilterBadge.style.display = 'none';
                    }
                }

                if (clearFiltersWrap) {
                    clearFiltersWrap.style.display = hasActiveFilters ? 'block' : 'none';
                }

                var filtered = rawLoadedProducts.filter(function(node) {
                    // Best Seller Tag Enforcement
                    if (isBestSellerMode) {
                        if (!isBestSellerProduct(node)) {
                            return false;
                        }
                    }

                    // Category Intent Check
                    if (detectedCategoryIntent) {
                        var pCat = getProductCategory(node);
                        if (pCat !== 'general' && pCat !== detectedCategoryIntent) {
                            return false;
                        }
                    }

                    // Specific Model / Name Enforcement
                    if (hasMatchingSpecificProducts && specificQueryKeywords.length > 0) {
                        var title = getProductTitle(node);
                        var anyLink = node.querySelector('a[href*="/products/"]');
                        var href = anyLink ? (anyLink.getAttribute('href') || '').toLowerCase() : '';
                        var varOptName = (node.getAttribute('data-variant-option-name') || '').toLowerCase();
                        var full = (title + ' ' + href + ' ' + varOptName);
                        var matchesSpecific = specificQueryKeywords.every(function(kw) {
                            return full.includes(kw);
                        });
                        if (!matchesSpecific) return false;
                    }

                    var isExpanded = node.hasAttribute('data-variant-expanded-id');
                    var varOptName = (node.getAttribute('data-variant-option-name') || '').toLowerCase();
                    var varTitle   = (node.getAttribute('data-variant-title') || '').toLowerCase();
                    var varOpt1    = (node.getAttribute('data-variant-option1') || '').toLowerCase();
                    var varOpt2    = (node.getAttribute('data-variant-option2') || '').toLowerCase();
                    var varOpt3    = (node.getAttribute('data-variant-option3') || '').toLowerCase();
                    var variantFull = (varOptName + ' ' + varTitle + ' ' + varOpt1 + ' ' + varOpt2 + ' ' + varOpt3).trim();
                    var productTags = getProductTags(node);
                    var tagsFull    = productTags.join(' ');
                    var isExpanded  = node.hasAttribute('data-variant-expanded-id');
                    var varOptName  = (node.getAttribute('data-variant-option-name') || '').toLowerCase();
                    var varTitle    = (node.getAttribute('data-variant-title') || '').toLowerCase();
                    var varOpt1     = (node.getAttribute('data-variant-option1') || '').toLowerCase();
                    var varOpt2     = (node.getAttribute('data-variant-option2') || '').toLowerCase();
                    var varOpt3     = (node.getAttribute('data-variant-option3') || '').toLowerCase();
                    var variantFull = (varOptName + ' ' + varTitle + ' ' + varOpt1 + ' ' + varOpt2 + ' ' + varOpt3).trim();
                    var fullText    = (node.textContent.toLowerCase() + ' ' + tagsFull).trim();
                    var price       = getProductPrice(node);

                    // A. Active Specific Category Filtering
                    if (catFilterInfo && catFilterInfo.keywords && catFilterInfo.keywords.length > 0) {
                        if (isExpanded) {
                            if (catFilterInfo.type === 'capacity' || catFilterInfo.type === 'size' || catFilterInfo.type === 'door') {
                                var matchVariantCat = catFilterInfo.keywords.some(function(kw) {
                                    return variantFull.includes(kw);
                                });
                                if (!matchVariantCat) return false;
                            } else {
                                var matchGeneralCat = catFilterInfo.keywords.some(function(kw) {
                                    return variantFull.includes(kw) || fullText.includes(kw) || productTags.some(function(t) { return t === kw || t.includes(kw); });
                                });
                                if (!matchGeneralCat) return false;
                            }
                        } else {
                            var matchUnexpandedCat = catFilterInfo.keywords.some(function(kw) {
                                return fullText.includes(kw) || productTags.some(function(t) { return t === kw || t.includes(kw); });
                            });
                            if (!matchUnexpandedCat) return false;
                        }
                    }

                    // B. Seating Capacity Checkbox Filters
                    if (activeCapacities.length > 0) {
                        var matchCap = activeCapacities.some(function(cap) {
                            var capKeywords = [cap, cap.replace(/\s+/g, '-'), cap.replace(/\s+/g, '')];
                            if (cap === '1 seater') capKeywords.push('1 seater', '1-seater', '1seater', 'one seater', '1 seat', '1-seat', '1s', 'armchair', 'single', 'recliner');
                            if (cap === '2 seater') capKeywords.push('2 seater', '2-seater', '2seater', 'two seater', '2 seat', '2-seat', '2s', 'loveseat');
                            if (cap === '3 seater') capKeywords.push('3 seater', '3-seater', '3seater', 'three seater', '3 seat', '3-seat', '3s');
                            if (cap === '4 seater') capKeywords.push('4 seater', '4-seater', '4seater', 'four seater', '4 seat', '4-seat', '4s');
                            if (cap === '5 seater') capKeywords.push('5 seater', '5-seater', '5seater', 'five seater', '5 seat', '5-seat', '5s', '3+2', '3 + 2', 'sectional');
                            if (cap === '6 seater') capKeywords.push('6 seater', '6-seater', '6seater', 'six seater', '6 seat', '6-seat', '6s');
                            if (cap === '8 seater') capKeywords.push('8 seater', '8-seater', '8seater', 'eight seater', '8 seat', '8-seat', '8s');
                            if (cap.includes('sectional') || cap.includes('l shape') || cap.includes('l-shape')) capKeywords.push('sectional', 'l shape', 'l-shape', 'l-shaped', 'l shaped', 'corner');

                            if (isExpanded) {
                                return capKeywords.some(function(kw) { return variantFull.includes(kw); });
                            } else {
                                return capKeywords.some(function(kw) {
                                    return fullText.includes(kw) || productTags.some(function(t) { return t === kw || t.includes(kw); });
                                });
                            }
                        });
                        if (!matchCap) return false;
                    }

                    // C. Shape Filter (Pills - Tags Primary)
                    if (activeShapes.length > 0) {
                        var matchShape = activeShapes.some(function(sh) {
                            var shKeywords = [sh];
                            if (sh === 'straight') shKeywords.push('straight', 'regular', 'standard');
                            if (sh === 'l-shape') shKeywords.push('l-shape', 'l shape', 'l-shaped', 'l shaped', 'corner', 'sectional');
                            if (sh === 'u-shape') shKeywords.push('u-shape', 'u shape', 'u-shaped');
                            if (sh === 'curved') shKeywords.push('curved', 'curve', 'round', 'arc');
                            if (sh === 'modular') shKeywords.push('modular', 'sectional');
                            if (sh === 'rectangular') shKeywords.push('rectangular', 'rectangle', 'rect');
                            if (sh === 'round') shKeywords.push('round', 'circular', 'circle');
                            if (sh === 'square') shKeywords.push('square');
                            if (sh === 'oval') shKeywords.push('oval', 'ellipse');
                            if (sh === 'nesting') shKeywords.push('nesting', 'nesting set', 'nest', 'nested');

                            // Tag check
                            var tagHit = productTags.some(function(t) {
                                return shKeywords.some(function(kw) { return t === kw || t.includes(kw); });
                            });
                            if (tagHit) return true;

                            if (sh === 'straight') {
                                if (isExpanded && (variantFull.includes('sectional') || variantFull.includes('l shape') || variantFull.includes('l-shape') || variantFull.includes('5 seater'))) return false;
                                return fullText.includes('straight') || fullText.includes('sofa') || fullText.includes('couch');
                            }
                            return shKeywords.some(function(kw) { return fullText.includes(kw) || variantFull.includes(kw); });
                        });
                        if (!matchShape) return false;
                    }

                    // D. Size Checkbox Filter (Beds)
                    if (activeSizes.length > 0) {
                        var matchSize = activeSizes.some(function(sz) {
                            var szKeywords = [sz];
                            if (sz.includes('king')) szKeywords.push('king size', 'king-size', 'kingsize', 'king');
                            if (sz.includes('queen')) szKeywords.push('queen size', 'queen-size', 'queensize', 'queen');
                            if (sz.includes('single')) szKeywords.push('single', 'single size', 'single bed', 'single-bed');
                            if (sz.includes('double')) szKeywords.push('double', 'double size', 'double bed', 'double-bed');

                            if (isExpanded) {
                                return szKeywords.some(function(kw) { return variantFull.includes(kw); });
                            } else {
                                return szKeywords.some(function(kw) {
                                    return fullText.includes(kw) || productTags.some(function(t) { return t === kw || t.includes(kw); });
                                });
                            }
                        });
                        if (!matchSize) return false;
                    }

                    // E. Door Count & Style (Wardrobes)
                    if (activeDoors.length > 0) {
                        var matchDoor = activeDoors.some(function(dr) {
                            var drKeywords = [dr];
                            if (dr === '2 door') drKeywords.push('2 door', '2-door', '2door', '2 doors', '2-doors', 'two door', 'two doors');
                            if (dr === '3 door') drKeywords.push('3 door', '3-door', '3door', '3 doors', '3-doors', 'three door', 'three doors');
                            if (dr === '4 door') drKeywords.push('4 door', '4-door', '4door', '4 doors', '4-doors', 'four door', 'four doors');
                            if (dr === 'sliding') drKeywords.push('sliding', 'sliding door', 'sliding-door', 'slider');
                            if (dr === 'hinged') drKeywords.push('hinged', 'hinged door', 'hinged-door', 'swing');

                            if (isExpanded) {
                                return drKeywords.some(function(kw) { return variantFull.includes(kw); });
                            } else {
                                return drKeywords.some(function(kw) {
                                    return fullText.includes(kw) || productTags.some(function(t) { return t === kw || t.includes(kw); });
                                });
                            }
                        });
                        if (!matchDoor) return false;
                    }

                    // F. Fabric Filter (Tags Primary)
                    if (activeFabrics.length > 0) {
                        var matchFab = activeFabrics.some(function(fb) {
                            var fbKeywords = [fb];
                            if (fb === 'cotton') fbKeywords.push('cotton', 'linen', 'fabric', 'polyester');
                            if (fb === 'leather') fbKeywords.push('leather', 'leatherette', 'faux leather', 'nappa');

                            var tagHit = productTags.some(function(t) {
                                return fbKeywords.some(function(kw) { return t === kw || t.includes(kw); });
                            });
                            if (tagHit) return true;

                            return isExpanded ? (fbKeywords.some(function(kw) { return variantFull.includes(kw) || fullText.includes(kw); })) : (fbKeywords.some(function(kw) { return fullText.includes(kw); }));
                        });
                        if (!matchFab) return false;
                    }

                    // G. Color Filter (Strict Variant/Swatch/Title matching & auto-swatch photo switch)
                    if (activeColors.length > 0) {
                        var colorKeywordsMap = {
                            'cream': ['cream', 'ivory', 'off-white', 'off white', 'warm white'],
                            'beige': ['beige', 'sand', 'nude', 'khaki', 'biscuit'],
                            'grey': ['grey', 'gray', 'charcoal', 'slate', 'ash', 'silver'],
                            'gray': ['grey', 'gray', 'charcoal', 'slate', 'ash', 'silver'],
                            'brown': ['brown', 'walnut', 'teak', 'tan', 'dark wood', 'coffee', 'chocolate'],
                            'green': ['green', 'olive', 'emerald', 'forest green', 'sage', 'moss', 'mint'],
                            'blue': ['blue', 'navy', 'royal blue', 'sky blue', 'teal', 'denim', 'indigo'],
                            'white': ['white', 'pure white', 'snow'],
                            'black': ['black', 'jet black', 'ebony'],
                            'gold': ['gold', 'brass', 'golden', 'yellow', 'mustard'],
                            'yellow': ['yellow', 'mustard', 'lemon', 'gold'],
                            'pink': ['pink', 'blush', 'rose', 'coral', 'peach'],
                            'red': ['red', 'maroon', 'burgundy', 'wine', 'crimson', 'ruby'],
                            'tan': ['tan', 'camel', 'taupe', 'cognac'],
                            'walnut': ['walnut', 'dark walnut', 'brown'],
                            'teak': ['teak', 'solid teak', 'natural teak', 'brown'],
                            'charcoal': ['charcoal', 'dark grey', 'anthracite'],
                            'navy': ['navy', 'navy blue', 'dark blue'],
                            'rust': ['rust', 'terracotta', 'burnt orange'],
                            'orange': ['orange', 'rust', 'terracotta', 'tangerine']
                        };

                        var matchedAnyColor = false;
                        var foundMatchingVariant = null;
                        var foundMatchingSwatch = null;

                        for (var c = 0; c < activeColors.length; c++) {
                            var cl = activeColors[c].toLowerCase().trim();
                            var kws = colorKeywordsMap[cl] || [cl];

                            // 1. Check existing swatch labels on this card
                            var swatches = Array.from(node.querySelectorAll('.swatch-label'));
                            for (var s = 0; s < swatches.length; s++) {
                                var sw = swatches[s];
                                var sVal = (sw.getAttribute('data-value') || '').toLowerCase();
                                var sTitle = (sw.getAttribute('title') || '').toLowerCase();
                                var isMatch = kws.some(function(kw) {
                                    return sVal === kw || sVal.includes(kw) || sTitle === kw || sTitle.includes(kw);
                                });
                                if (isMatch) {
                                    matchedAnyColor = true;
                                    foundMatchingSwatch = sw;
                                    break;
                                }
                            }
                            if (matchedAnyColor) break;

                            // 2. Check JSON product variants if available
                            var jsonEl = node.querySelector('[data-json-product]') || node;
                            var jsonAttr = jsonEl ? jsonEl.getAttribute('data-json-product') : null;
                            if (jsonAttr) {
                                try {
                                    var pData = typeof jsonAttr === 'object' ? jsonAttr : JSON.parse(jsonAttr);
                                    if (pData && pData.variants) {
                                        var vMatch = pData.variants.find(function(v) {
                                            var vStr = ((v.title || '') + ' ' + (v.option1 || '') + ' ' + (v.option2 || '') + ' ' + (v.option3 || '')).toLowerCase();
                                            return kws.some(function(kw) { return vStr.includes(kw); });
                                        });
                                        if (vMatch) {
                                            matchedAnyColor = true;
                                            foundMatchingVariant = { variant: vMatch, pData: pData };
                                            break;
                                        }
                                    }
                                } catch(e) {}
                            }
                            if (matchedAnyColor) break;

                            // 3. Check card Title (e.g. "Rosario Sofa in Cream Velvet")
                            var title = getProductTitle(node).toLowerCase();
                            if (kws.some(function(kw) { return title.includes(kw); })) {
                                matchedAnyColor = true;
                                break;
                            }

                            // 4. Check explicit color tags (e.g. color:cream or exact tag 'cream')
                            var pTags = getProductTags(node);
                            var tagMatch = pTags.some(function(t) {
                                var tLow = t.toLowerCase().trim();
                                return kws.some(function(kw) {
                                    return tLow === kw || tLow === 'color:' + kw || tLow === 'color_' + kw;
                                });
                            });
                            if (tagMatch) {
                                matchedAnyColor = true;
                                break;
                            }
                        }

                        if (!matchedAnyColor) return false;

                        // If matching swatch found on card, activate it and sync image & price!
                        if (foundMatchingSwatch) {
                            var cardSwatches = node.querySelectorAll('.swatch-label');
                            cardSwatches.forEach(function(l) { l.classList.remove('is-active'); });
                            foundMatchingSwatch.classList.add('is-active');

                            var vId = foundMatchingSwatch.getAttribute('data-variant-id');
                            var jsonEl = node.querySelector('[data-json-product]') || node;
                            var jsonAttr = jsonEl ? jsonEl.getAttribute('data-json-product') : null;
                            if (jsonAttr && vId) {
                                try {
                                    var pData = typeof jsonAttr === 'object' ? jsonAttr : JSON.parse(jsonAttr);
                                    var foundV = (pData.variants || []).find(function(v) { return String(v.id) === String(vId); });
                                    if (foundV) {
                                        syncCardVariantDisplay(node, { variant: foundV, pData: pData });
                                    }
                                } catch(e) {}
                            }
                        } else if (foundMatchingVariant) {
                            syncCardVariantDisplay(node, foundMatchingVariant);
                        }
                    }

                    // H. Material Filter (Tags Primary)
                    if (activeMaterials.length > 0) {
                        var matchMat = activeMaterials.some(function(mt) {
                            var mtKeywords = [mt];
                            if (mt === 'teak') mtKeywords.push('teak', 'teak wood', 'teakwood', 'solid teak', 'teak finish');
                            if (mt === 'wood') mtKeywords.push('solid wood', 'wood', 'sheesham', 'oak', 'walnut', 'hardwood', 'mango wood');
                            if (mt === 'metal') mtKeywords.push('metal', 'steel', 'ss metal', 'stainless steel', 'brass', 'iron', 'gold metal');
                            if (mt === 'marble') mtKeywords.push('marble', 'marble top', 'stone', 'travertine', 'quartz');
                            if (mt === 'glass') mtKeywords.push('glass', 'glass top', 'tempered glass');
                            if (mt === 'ceramic') mtKeywords.push('ceramic', 'onyx', 'porcelain', 'sintered stone');
                            if (mt === 'cane') mtKeywords.push('cane', 'rattan', 'wicker');
                            if (mt === 'upholstered') mtKeywords.push('upholstered', 'upholstery', 'fabric', 'cushioned', 'velvet');
                            if (mt === 'mirror') mtKeywords.push('mirror', 'glass front', 'mirrored');

                            var tagHit = productTags.some(function(t) {
                                return mtKeywords.some(function(kw) { return t === kw || t.includes(kw); });
                            });
                            if (tagHit) return true;

                            return mtKeywords.some(function(kw) { return fullText.includes(kw); });
                        });
                        if (!matchMat) return false;
                    }

                    // I. Feature Filter (Tags Primary)
                    if (activeFeatures.length > 0) {
                        var matchFeat = activeFeatures.some(function(ft) {
                            var ftKeywords = [ft];
                            if (ft === 'hydraulic') ftKeywords.push('hydraulic', 'hydraulic storage', 'lift up', 'gas lift', 'hydraulic bed');
                            if (ft === 'drawer') ftKeywords.push('drawer', 'drawers', 'with drawers', 'with drawer', 'drawer storage');
                            if (ft === 'box') ftKeywords.push('box', 'box storage', 'manual storage');
                            if (ft === 'without storage') ftKeywords.push('without storage', 'no storage', 'non-storage', 'plain');
                            if (ft === 'recliner') ftKeywords.push('recliner', 'recline', 'recliners', 'rocker recliner');
                            if (ft === 'motorized') ftKeywords.push('motorized', 'motorised', 'electric', 'power', 'motor');
                            if (ft === 'convertible') ftKeywords.push('sofa bed', 'sofa-bed', 'convertible', 'cum bed', 'sofa cum bed');
                            if (ft === 'storage') ftKeywords.push('storage', 'with storage', 'drawer');
                            if (ft === 'mirror') ftKeywords.push('mirror', 'with mirror', 'mirrored');
                            if (ft === 'locker') ftKeywords.push('locker', 'safe', 'lock', 'with locker');
                            if (ft === 'nesting') ftKeywords.push('nesting', 'nesting set', 'nest of tables', 'nested');
                            if (ft === 'dining chair') ftKeywords.push('dining chair', 'dining chairs');
                            if (ft === 'accent chair') ftKeywords.push('accent chair', 'accent chairs', 'lounge chair');
                            if (ft === 'armchair') ftKeywords.push('armchair', 'armchairs', 'arm chair');
                            if (ft === 'bar stool') ftKeywords.push('bar stool', 'bar stools', 'counter stool', 'stool');
                            if (ft === 'tv') ftKeywords.push('tv console', 'tv unit', 'tv stand', 'media unit', 'entertainment unit');
                            if (ft === 'sideboard') ftKeywords.push('sideboard', 'credenza', 'buffet', 'cabinet');
                            if (ft === 'shoe') ftKeywords.push('shoe rack', 'shoe cabinet', 'shoe storage', 'shoe');
                            if (ft === 'book') ftKeywords.push('bookshelf', 'bookcase', 'book shelf', 'book');
                            if (ft === 'floor lamp') ftKeywords.push('floor lamp', 'standing lamp', 'floor light');
                            if (ft === 'table lamp') ftKeywords.push('table lamp', 'desk lamp', 'table light');
                            if (ft === 'pendant') ftKeywords.push('pendant', 'hanging light', 'chandelier', 'ceiling light');

                            var tagHit = productTags.some(function(t) {
                                return ftKeywords.some(function(kw) { return t === kw || t.includes(kw); });
                            });
                            if (tagHit) return true;

                            if (ft === 'without storage') {
                                return !productTags.some(function(t) { return t.includes('storage') || t.includes('hydraulic'); }) && !fullText.includes('storage') && !fullText.includes('hydraulic');
                            }

                            return ftKeywords.some(function(kw) { return fullText.includes(kw); });
                        });
                        if (!matchFeat) return false;
                    }

                    // J. Price Filter
                    if (activePrices.length > 0) {
                        var matchPrice = activePrices.some(function(pRange) {
                            var parts = pRange.split('-');
                            var min = parseFloat(parts[0]);
                            var max = parseFloat(parts[1]);
                            return price >= min && price <= max;
                        });
                        if (!matchPrice) return false;
                    }

                    return true;
                });

                var sortVal = sortSelect ? sortSelect.value : 'manual';
                filtered.sort(function(a, b) {
                    if (sortVal === 'price-ascending') {
                        return getProductPrice(a) - getProductPrice(b);
                    }
                    if (sortVal === 'price-descending') {
                        return getProductPrice(b) - getProductPrice(a);
                    }
                    if (sortVal === 'created-descending') {
                        return getProductTitle(a).localeCompare(getProductTitle(b));
                    }
                    if (activeSearchQuery) {
                        var scoreA = getProductRelevanceScore(a, activeSearchQuery);
                        var scoreB = getProductRelevanceScore(b, activeSearchQuery);
                        if (scoreB !== scoreA) {
                            return scoreB - scoreA;
                        }
                    }
                    return 0;
                });

                // Deduplicate to single variant when an "All" type or general category is active without specific variant filter
                var isSpecificVariantCategory = !!(catFilterInfo && (catFilterInfo.type === 'capacity' || catFilterInfo.type === 'size' || catFilterInfo.type === 'door'));
                var hasVariantOptionFilter = (activeCapacities.length > 0 || activeSizes.length > 0 || activeDoors.length > 0);

                if (!isSpecificVariantCategory && !hasVariantOptionFilter && (isAllTypeCategory(currentCategoryName) || !catFilterInfo || catFilterInfo.type === 'general')) {
                    var seenBaseProducts = new Set();
                    filtered = filtered.filter(function(node) {
                        var baseKey = node.getAttribute('data-base-product-handle') ||
                                      (node.querySelector('a[href*="/products/"]') ? node.querySelector('a[href*="/products/"]').getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0] : null) ||
                                      node.getAttribute('data-product-id') ||
                                      getProductTitle(node);
                        if (!baseKey) return true;
                        if (seenBaseProducts.has(baseKey)) {
                            return false;
                        }
                        seenBaseProducts.add(baseKey);
                        return true;
                    });
                }

                currentFilteredProducts = filtered;

                if (resultsHeading) {
                    resultsHeading.textContent = 'Results';
                }

                renderCurrentPage();
            }

            function getCategoryFilterType(catKey, catName) {
                var raw = ((catKey || '') + ' ' + (catName || '')).toLowerCase();
                if (raw.includes('sofa') || raw.includes('couch') || raw.includes('recliner') || raw.includes('living')) return 'sofas';
                if (raw.includes('dining')) return 'dining';
                if (raw.includes('bed')) return 'beds';
                if (raw.includes('wardrobe') || raw.includes('closet') || raw.includes('almirah')) return 'wardrobes';
                if (raw.includes('table') || raw.includes('desk') || raw.includes('console')) return 'tables';
                if (raw.includes('chair') || raw.includes('stool') || raw.includes('bench')) return 'chairs';
                if (raw.includes('storage') || raw.includes('sideboard') || raw.includes('tv') || raw.includes('cabinet') || raw.includes('drawer')) return 'storage';
                if (raw.includes('decor') || raw.includes('lamp') || raw.includes('light') || raw.includes('mirror') || raw.includes('rug')) return 'decor';
                return 'general';
            }

            function renderCategoryFilters(catKey, catName) {
                var container = document.getElementById('sidebar-dynamic-filters-wrap');
                if (!container) return;

                var type = getCategoryFilterType(catKey, catName);
                
                // 1. Check if admin configured custom filter blocks exist in the DOM
                var adminConfigs = Array.from(document.querySelectorAll('.custom-admin-filter-config'));
                var curType = (type || '').toLowerCase().trim();
                var curKey = (catKey || '').toLowerCase().trim();
                var curName = (catName || '').toLowerCase().trim();

                var matchingAdminBlocks = adminConfigs.filter(function(block) {
                    var targetCat = (block.getAttribute('data-filter-category') || 'all').toLowerCase().trim();
                    if (targetCat === 'all' || targetCat === '' || targetCat === 'any') return true;
                    var targets = targetCat.split(/[,|]+/).map(function(s) { return s.trim().toLowerCase(); });
                    return targets.some(function(t) {
                        return t === 'all' ||
                               t === curType || t === curType.replace(/s$/, '') || (t + 's') === curType ||
                               t === curKey  || t === curKey.replace(/s$/, '')  || (t + 's') === curKey ||
                               t === curName || t === curName.replace(/s$/, '') || (t + 's') === curName ||
                               curName.includes(t) || curKey.includes(t);
                    });
                });

                var html = '';

                if (matchingAdminBlocks.length > 0) {
                    matchingAdminBlocks.forEach(function(block) {
                        var title = block.getAttribute('data-filter-title') || 'Filter';
                        var filterType = (block.getAttribute('data-filter-type') || 'checkbox').toLowerCase().trim();
                        var optionsRaw = block.getAttribute('data-filter-options') || '';
                        var options = optionsRaw.split(/[\n,]+/).map(function(s) { return s.trim(); }).filter(Boolean);

                        var lowTitle = title.toLowerCase();
                        var isColorBlock = filterType === 'color' || lowTitle === 'colour' || lowTitle === 'color' || lowTitle.includes('colour') || lowTitle.includes('color');
                        var isPriceBlock = filterType === 'price' || lowTitle === 'price' || lowTitle.includes('price');

                        if (isColorBlock) {
                            return; // User requested to completely remove the colour filter
                        } else if (isPriceBlock) {
                            var priceItems = [];
                            if (optionsRaw.includes('\n')) {
                                priceItems = optionsRaw.split('\n').map(function(s) { return s.trim(); }).filter(Boolean);
                            } else if (optionsRaw.includes(';')) {
                                priceItems = optionsRaw.split(';').map(function(s) { return s.trim(); }).filter(Boolean);
                            } else if (optionsRaw.includes(':')) {
                                var regex = /([^:]+?)\s*:\s*([0-9]+-[0-9]+)/g;
                                var m;
                                while ((m = regex.exec(optionsRaw)) !== null) {
                                    priceItems.push(m[1].trim() + ':' + m[2].trim());
                                }
                            }
                            if (priceItems.length === 0) {
                                priceItems = [
                                    'Under ₹25,000:0-25000',
                                    '₹25,000 - ₹50,000:25000-50000',
                                    '₹50,000 - ₹1,00,000:50000-100000',
                                    'Above ₹1,00,000:100000-9999999'
                                ];
                            }

                            html += '<div class="sidebar-filter-group filter-accordion-group">'
                                  + '  <div class="accordion-item">'
                                  + '    <button type="button" class="accordion-btn">' + title + ' <span class="accordion-icon">+</span></button>'
                                  + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                                  + '      <div class="filter-checkbox-list">';
                            priceItems.forEach(function(item) {
                                var parts = item.split(':');
                                var label = parts[0].trim();
                                var rangeVal = (parts[1] || parts[0]).trim();
                                if (!rangeVal.includes('-')) {
                                    var low = label.toLowerCase();
                                    if (low.includes('25') && (low.includes('under') || low.includes('below') || low.includes('less'))) rangeVal = '0-25000';
                                    else if (low.includes('25') && low.includes('50')) rangeVal = '25000-50000';
                                    else if (low.includes('50') && (low.includes('100') || low.includes('1,00') || low.includes('1 lakh'))) rangeVal = '50000-100000';
                                    else if (low.includes('100') || low.includes('1,00') || low.includes('above') || low.includes('over')) rangeVal = '100000-9999999';
                                    else rangeVal = '0-9999999';
                                }
                                html += '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="' + rangeVal + '"> <span>' + label + '</span></label>';
                            });
                            html += '      </div>'
                                  + '    </div>'
                                  + '  </div>'
                                  + '</div>';
                        } else if (filterType === 'checkbox') {
                            html += '<div class="sidebar-filter-group">'
                                  + '  <h3 class="sidebar-filter-title">' + title + '</h3>'
                                  + '  <div class="filter-checkbox-list">';
                            options.forEach(function(opt) {
                                var val = opt.toLowerCase();
                                var checkboxClass = 'filter-feature-checkbox';
                                if (lowTitle.includes('capacity') || lowTitle.includes('seater')) checkboxClass = 'filter-capacity-checkbox';
                                else if (lowTitle.includes('door')) checkboxClass = 'filter-door-checkbox';
                                else if (lowTitle.includes('size')) checkboxClass = 'filter-size-checkbox';
                                else if (lowTitle.includes('material')) checkboxClass = 'filter-material-checkbox';
                                else if (lowTitle.includes('fabric')) checkboxClass = 'filter-fabric-checkbox';

                                html += '    <label class="filter-checkbox-label"><input type="checkbox" class="' + checkboxClass + '" value="' + val + '"> <span>' + opt + '</span></label>';
                            });
                            html += '  </div>'
                                  + '</div>';
                        } else if (filterType === 'accordion') {
                            html += '<div class="sidebar-filter-group filter-accordion-group">'
                                  + '  <div class="accordion-item">'
                                  + '    <button type="button" class="accordion-btn">' + title + ' <span class="accordion-icon">+</span></button>'
                                  + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                                  + '      <div class="filter-checkbox-list">';
                            options.forEach(function(opt) {
                                var val = opt.toLowerCase();
                                var checkboxClass = 'filter-feature-checkbox';
                                if (lowTitle.includes('capacity') || lowTitle.includes('seater')) checkboxClass = 'filter-capacity-checkbox';
                                else if (lowTitle.includes('door')) checkboxClass = 'filter-door-checkbox';
                                else if (lowTitle.includes('size')) checkboxClass = 'filter-size-checkbox';
                                else if (lowTitle.includes('material')) checkboxClass = 'filter-material-checkbox';
                                else if (lowTitle.includes('fabric')) checkboxClass = 'filter-fabric-checkbox';

                                html += '        <label class="filter-checkbox-label"><input type="checkbox" class="' + checkboxClass + '" value="' + val + '"> <span>' + opt + '</span></label>';
                            });
                            html += '      </div>'
                                  + '    </div>'
                                  + '  </div>'
                                  + '</div>';
                        } else if (filterType === 'shape') {
                            html += '<div class="sidebar-filter-group">'
                                  + '  <h3 class="sidebar-filter-title">' + title + '</h3>'
                                  + '  <div class="filter-shape-grid filter-shape-list">';
                            options.forEach(function(opt) {
                                var val = opt.toLowerCase().replace(/\s+/g, '-');
                                html += '    <button class="shape-pill shape-list-item" type="button" data-shape="' + val + '"><span>' + opt + '</span></button>';
                            });
                            html += '  </div>'
                                  + '</div>';
                        }
                    });
                } else if (type === 'sofas') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Seating Capacity</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="1 seater"> <span>1 Seater / Recliner</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="2 seater"> <span>2 Seater</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="3 seater"> <span>3 Seater</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="4 seater"> <span>4 Seater</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="5 seater"> <span>5 Seater & Above / Sectional</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Shape</h3>'
                          + '  <div class="filter-shape-grid filter-shape-list">'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="straight"><span class="shape-svg-icon"><svg width="22" height="15" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h18v6H3z"/><path d="M1 6h2v6H1z"/><path d="M21 6h2v6H21z"/><path d="M4 12v3"/><path d="M20 12v3"/><path d="M3 10h18"/></svg></span><span>Straight</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="l-shape"><span class="shape-svg-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h7v6h11v12H3V3z"/><path d="M3 9h7v12"/><path d="M10 9h11"/></svg></span><span>L-Shape</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="u-shape"><span class="shape-svg-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h5v8h8V3h5v18H3V3z"/><path d="M8 3v8h8V3"/><path d="M3 15h18"/></svg></span><span>U-Shape</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="curved"><span class="shape-svg-icon"><svg width="20" height="15" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 13C2 5 22 5 22 13"/><path d="M5 13C5 8 19 8 19 13"/><path d="M2 13h3m14 0h3"/></svg></span><span>Curved</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="modular"><span class="shape-svg-icon"><svg width="22" height="15" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="9" height="10" rx="1.5"/><rect x="13" y="3" width="9" height="10" rx="1.5"/><line x1="2" y1="8" x2="11" y2="8"/><line x1="13" y1="8" x2="22" y2="8"/></svg></span><span>Modular</span></button>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Fabric <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-fabric-checkbox" value="velvet"> <span>Velvet</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-fabric-checkbox" value="suede"> <span>Suede</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-fabric-checkbox" value="leather"> <span>Leather</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-fabric-checkbox" value="boucle"> <span>Boucle</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-fabric-checkbox" value="cotton"> <span>Cotton / Linen</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Features <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="recliner"> <span>Recliner</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="motorized"> <span>Motorized</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="convertible"> <span>Sofa Bed / Convertible</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="storage"> <span>Storage</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else if (type === 'dining') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Seating Capacity</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="2 seater"> <span>2 Seater</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="4 seater"> <span>4 Seater</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="6 seater"> <span>6 Seater</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-capacity-checkbox" value="8 seater"> <span>8 Seater & Above</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Table Shape</h3>'
                          + '  <div class="filter-shape-grid filter-shape-list">'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="rectangular"><span class="shape-svg-icon"><svg width="22" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="7" rx="1.5"/><line x1="5" y1="11" x2="5" y2="15"/><line x1="19" y1="11" x2="19" y2="15"/></svg></span><span>Rectangular</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="round"><span class="shape-svg-icon"><svg width="20" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="7" rx="8" ry="4"/><line x1="12" y1="11" x2="12" y2="15"/><line x1="8" y1="15" x2="16" y2="15"/></svg></span><span>Round</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="square"><span class="shape-svg-icon"><svg width="18" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="9" rx="1.5"/><line x1="7" y1="12" x2="7" y2="15"/><line x1="17" y1="12" x2="17" y2="15"/></svg></span><span>Square</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="oval"><span class="shape-svg-icon"><svg width="22" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="7" rx="10" ry="4.5"/><line x1="6" y1="11.5" x2="6" y2="15"/><line x1="18" y1="11.5" x2="18" y2="15"/></svg></span><span>Oval</span></button>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Table Top Material <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="marble"> <span>Marble Top</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="teak"> <span>Solid Teak Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="glass"> <span>Glass Top</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="ceramic"> <span>Onyx / Ceramic</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else if (type === 'beds') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Bed Size</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-size-checkbox" value="king size"> <span>King Size</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-size-checkbox" value="queen size"> <span>Queen Size</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-size-checkbox" value="single bed"> <span>Single Bed</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-size-checkbox" value="double bed"> <span>Double Bed</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Storage Type</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="hydraulic"> <span>Hydraulic Storage</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="drawer"> <span>Drawer Storage</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="box"> <span>Box Storage</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="without storage"> <span>Without Storage</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Headboard & Material <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="upholstered"> <span>Upholstered / Cushioned</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="teak"> <span>Solid Teak Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="cane"> <span>Cane / Rattan</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="wood"> <span>Solid Wood</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else if (type === 'wardrobes') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Door Count & Style</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-door-checkbox" value="2 door"> <span>2 Door</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-door-checkbox" value="3 door"> <span>3 Door</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-door-checkbox" value="4 door"> <span>4 Door</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-door-checkbox" value="sliding"> <span>Sliding Door</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-door-checkbox" value="hinged"> <span>Hinged Door</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Material & Finish <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="teak"> <span>Solid Teak Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="wood"> <span>Solid Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="mirror"> <span>Mirror / Glass Front</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Features <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="mirror"> <span>With Mirror</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="drawer"> <span>With Drawers</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="locker"> <span>Locker Storage</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else if (type === 'tables') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Table Shape</h3>'
                          + '  <div class="filter-shape-grid filter-shape-list">'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="round"><span class="shape-svg-icon"><svg width="20" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="7" rx="8" ry="4"/><line x1="12" y1="11" x2="12" y2="15"/><line x1="8" y1="15" x2="16" y2="15"/></svg></span><span>Round</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="rectangular"><span class="shape-svg-icon"><svg width="22" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="7" rx="1.5"/><line x1="5" y1="11" x2="5" y2="15"/><line x1="19" y1="11" x2="19" y2="15"/></svg></span><span>Rectangular</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="square"><span class="shape-svg-icon"><svg width="18" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="9" rx="1.5"/><line x1="7" y1="12" x2="7" y2="15"/><line x1="17" y1="12" x2="17" y2="15"/></svg></span><span>Square</span></button>'
                          + '    <button class="shape-pill shape-list-item" type="button" data-shape="nesting"><span class="shape-svg-icon"><svg width="22" height="16" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="9" cy="6" rx="6" ry="3.5"/><ellipse cx="15" cy="8" rx="5" ry="3"/><line x1="9" y1="9.5" x2="9" y2="14"/><line x1="15" y1="11" x2="15" y2="14"/></svg></span><span>Nesting Set</span></button>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Material <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="marble"> <span>Marble Top</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="teak"> <span>Solid Teak Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="metal"> <span>Metal Frame</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="glass"> <span>Glass Top</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Features <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="drawer"> <span>With Drawers / Storage</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="nesting"> <span>Nesting Set</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else if (type === 'chairs') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Chair Type</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="dining chair"> <span>Dining Chairs</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="accent chair"> <span>Accent Chairs</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="armchair"> <span>Armchairs</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="lounge chair"> <span>Lounge Chairs</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="bar stool"> <span>Bar Stools</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Material & Fabric <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="teak"> <span>Solid Teak Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-fabric-checkbox" value="fabric"> <span>Upholstered Fabric</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-fabric-checkbox" value="leather"> <span>Leatherette</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="metal"> <span>Metal Frame</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else if (type === 'storage') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Storage Type</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="tv"> <span>TV Console / Unit</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="sideboard"> <span>Sideboard / Credenza</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="shoe"> <span>Shoe Rack</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="book"> <span>Bookshelf</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="drawer"> <span>Chest of Drawers</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Material <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="teak"> <span>Solid Teak Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="wood"> <span>Solid Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="cane"> <span>Cane / Rattan</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="metal"> <span>Metal Frame</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else if (type === 'decor') {
                    html += '<div class="sidebar-filter-group">'
                          + '  <h3 class="sidebar-filter-title">Type</h3>'
                          + '  <div class="filter-checkbox-list">'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="floor lamp"> <span>Floor Lamps</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="table lamp"> <span>Table Lamps</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="pendant"> <span>Pendant Lights</span></label>'
                          + '    <label class="filter-checkbox-label"><input type="checkbox" class="filter-feature-checkbox" value="mirror"> <span>Mirrors & Art</span></label>'
                          + '  </div>'
                          + '</div>'
                          + '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Material <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="brass"> <span>Brass / Gold Metal</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="ceramic"> <span>Ceramic</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="glass"> <span>Glass</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="wood"> <span>Solid Wood</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                } else {
                    // General / All Categories / Custom Category fallback
                    html += '<div class="sidebar-filter-group filter-accordion-group">'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Material <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="teak"> <span>Solid Teak Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="wood"> <span>Solid Wood</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="marble"> <span>Marble</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="metal"> <span>SS Metal / Brass</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="glass"> <span>Glass</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-material-checkbox" value="fabric"> <span>Fabric Upholstery</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '  <div class="accordion-item">'
                          + '    <button type="button" class="accordion-btn">Price <span class="accordion-icon">+</span></button>'
                          + '    <div class="accordion-content" style="display: none; padding: 10px 0;">'
                          + '      <div class="filter-checkbox-list">'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="0-25000"> <span>Under ₹25,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="25000-50000"> <span>₹25,000 - ₹50,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="50000-100000"> <span>₹50,000 - ₹1,00,000</span></label>'
                          + '        <label class="filter-checkbox-label"><input type="checkbox" class="filter-price-checkbox" value="100000-9999999"> <span>Above ₹1,00,000</span></label>'
                          + '      </div>'
                          + '    </div>'
                          + '  </div>'
                          + '</div>';
                }

                container.innerHTML = html;
                initFilterEventListeners();
                initAccordionToggles();
            }

            function initAccordionToggles() {
                var accBtns = document.querySelectorAll('.filter-accordion-group .accordion-btn');
                accBtns.forEach(function(btn) {
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        var content = btn.nextElementSibling;
                        var icon = btn.querySelector('.accordion-icon, span');
                        if (content && content.classList.contains('accordion-content')) {
                            var isOpen = content.style.display !== 'none';
                            content.style.display = isOpen ? 'none' : 'block';
                            if (icon) icon.textContent = isOpen ? '+' : '−';
                        }
                    });
                });
            }

            function initFilterEventListeners() {
                var allCheckboxes = document.querySelectorAll('.filter-checkbox-list input[type="checkbox"]');
                allCheckboxes.forEach(function(cb) {
                    cb.addEventListener('change', function() {
                        applyFiltersAndSort(true);
                    });
                });

                var shapePills = document.querySelectorAll('.shape-pill');
                shapePills.forEach(function(pill) {
                    pill.addEventListener('click', function(e) {
                        e.preventDefault();
                        pill.classList.toggle('is-active');
                        applyFiltersAndSort(true);
                    });
                });

                var colorSwatches = document.querySelectorAll('.color-swatch-btn');
                colorSwatches.forEach(function(swatch) {
                    swatch.addEventListener('click', function(e) {
                        e.preventDefault();
                        swatch.classList.toggle('is-active');
                        if (swatch.classList.contains('is-active')) {
                            swatch.style.outline = '2px solid #2b241d';
                            swatch.style.outlineOffset = '2px';
                        } else {
                            swatch.style.outline = 'none';
                        }
                        applyFiltersAndSort(true);
                    });
                });

                if (sortSelect) {
                    sortSelect.addEventListener('change', function() {
                        applyFiltersAndSort(true);
                    });
                }

                var viewBtns = document.querySelectorAll('.toolbar-view-mode .view-btn');
                viewBtns.forEach(function(vBtn) {
                    vBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        viewBtns.forEach(function(b) { b.classList.remove('is-active'); });
                        vBtn.classList.add('is-active');
                        var viewMode = vBtn.getAttribute('data-view');
                        currentViewColumns = parseInt(viewMode, 10) || 3;
                        if (currentViewColumns === 2) {
                            productGrid.className = 'productListing productGrid column-2 list-unstyled';
                        } else if (currentViewColumns === 1) {
                            productGrid.className = 'productListing productGrid column-1 list-unstyled productList';
                        } else {
                            productGrid.className = 'productListing productGrid column-3 list-unstyled';
                        }
                        currentPage = 1;
                        renderCurrentPage();
                    });
                });

                if (clearFiltersBtn) {
                    clearFiltersBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        var allCbs = document.querySelectorAll('.filter-checkbox-list input[type="checkbox"]');
                        allCbs.forEach(function(cb) { cb.checked = false; });
                        var pills = document.querySelectorAll('.shape-pill');
                        pills.forEach(function(pill) {
                            pill.classList.remove('is-active');
                        });
                        var swatches = document.querySelectorAll('.color-swatch-btn');
                        swatches.forEach(function(swatch) {
                            swatch.classList.remove('is-active');
                            swatch.style.outline = 'none';
                        });
                        applyFiltersAndSort(true);
                    });
                }

                function triggerLandingSearch() {
                    var input = searchLandingInput || (searchLandingForm ? searchLandingForm.querySelector('input[name="q"]') : null);
                    if (!input) return;
                    var queryVal = input.value.trim();
                    if (!queryVal) return;

                    currentSearchQuery = queryVal;
                    if (window.history && window.history.pushState) {
                        window.history.pushState(null, '', '/search?q=' + encodeURIComponent(queryVal));
                    }

                    // Dismiss predictive search suggestions dropdown immediately
                    if (typeof window.hidePredictiveSearch === 'function') {
                        window.hidePredictiveSearch();
                    }
                    document.dispatchEvent(new CustomEvent('predictive-search:hide'));
                    var psDrop = document.querySelector('.predictive-search-dropdown');
                    if (psDrop) {
                        psDrop.style.display = 'none';
                        psDrop.innerHTML = '';
                    }
                    input.blur();

                    renderSidebar('top', '/collections/all');
                    loadProducts('Results for "' + queryVal + '"', '/search?q=' + encodeURIComponent(queryVal) + '&type=product');
                }

                if (searchLandingForm) {
                    searchLandingForm.addEventListener('submit', function(e) {
                        e.preventDefault();
                        triggerLandingSearch();
                    });
                }

                if (searchLandingInput) {
                    searchLandingInput.addEventListener('keydown', function(e) {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            e.preventDefault();
                            triggerLandingSearch();
                        }
                    });
                }
            }

            function renderSidebar(groupKey, activeUrl) {
                currentGroupKey = groupKey;
                var items = categoryDataMap[groupKey] || categoryDataMap['top'];
                var html  = '';

                if (groupKey !== 'top') {
                    html += '<li class="search-cat-item back-item" style="margin-bottom:6px;">'                          + '<button type="button" class="back-to-top-btn" '                          + 'style="background:none;border:none;color:#8b5e3c;font-size:12px;'                          + 'font-weight:600;cursor:pointer;padding:4px 0;display:flex;'                          + 'align-items:center;gap:4px;">← All Categories</button></li>';
                }

                items.forEach(function(item) {
                    var active   = item.url === activeUrl ||
                                   (activeUrl && item.url && (item.url.replace(/\/$/, '') === activeUrl.replace(/\/$/, ''))) ||
                                   (item.key && activeUrl && (activeUrl === item.key || activeUrl.endsWith('/' + item.key)));
                    var keyAttr  = item.key ? ' data-cat-key="' + item.key + '"' : '';
                    html += '<li class="search-cat-item' + (active ? ' is-active' : '') + '">'                          + '<a href="' + item.url + '" class="search-cat-link"' + keyAttr + '>'                          + item.name + '</a></li>';
                });

                dynamicList.innerHTML = html;
                renderCategoryFilters(groupKey, currentCategoryName);
                bindEvents();
            }

            function loadProducts(catName, targetUrl) {
                if (!catName || !productGrid) return;
                currentCategoryName = catName;
                currentPage = 1;
                var thisFetchId = ++activeFetchId;
                isFetching = true;

                if (heroTitle)      heroTitle.textContent    = catName;
                if (heroSubtitle)   heroSubtitle.textContent = 'Explore our handcrafted ' + catName.toLowerCase() + ' collection built for modern living.';
                if (resultsHeading) resultsHeading.textContent = 'Results';

                // Automatically render Category-Specific Filters for this selected category
                renderCategoryFilters(currentGroupKey, catName);

                // Display Shimmer Skeleton immediately so user sees active loading
                renderShimmerSkeleton();

                var seen = new Set();
                rawLoadedProducts = [];
                currentFilteredProducts = [];
                var pagesData = {};

                function extractPageElements(html) {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = html;

                    var grid = tmp.querySelector('#main-collection-product-grid')
                            || tmp.querySelector('#landing-bestsellers-product-grid')
                            || tmp.querySelector('.search-landing-main .productListing')
                            || tmp.querySelector('.collection .productListing')
                            || tmp.querySelector('.productListing');

                    var els = grid
                        ? Array.from(grid.children).filter(function(c) {
                            return c.tagName.toLowerCase() === 'li' || c.classList.contains('product');
                          })
                        : Array.from(tmp.querySelectorAll('li.product, .productGrid > li'));

                    return els;
                }

                function expandProductVariants(el) {
                    var jsonItem = el.querySelector('[data-json-product]') || el;
                    var jsonStr = jsonItem ? jsonItem.getAttribute('data-json-product') : null;
                    if (!jsonStr) return [el];

                    try {
                        var pData = typeof jsonStr === 'object' ? jsonStr : JSON.parse(jsonStr);
                        if (!pData || !pData.variants || pData.variants.length <= 1) {
                            return [el];
                        }

                        // Extract original swatch style map from el
                        var originalStyleMap = {};
                        var origLabels = el.querySelectorAll('.swatch-label');
                        origLabels.forEach(function(l) {
                            var key1 = (l.getAttribute('data-value') || '').toLowerCase().trim();
                            var key2 = (l.getAttribute('title') || '').toLowerCase().trim();
                            var pat = l.querySelector('.pattern');
                            var styleVal = pat ? pat.getAttribute('style') : '';
                            if (key1 && styleVal) originalStyleMap[key1] = styleVal;
                            if (key2 && styleVal) originalStyleMap[key2] = styleVal;
                        });

                        // Helper to determine seating and color for any variant
                        function getVariantDetails(v) {
                            var opts = (v.options && v.options.length > 0) ? v.options : [v.option1, v.option2, v.option3].filter(Boolean);
                            if (opts.length === 0 && v.title && v.title.includes('/')) {
                                opts = v.title.split('/').map(function(s) { return s.trim(); });
                            }

                            var seating = '';
                            var col = '';

                            for (var i = 0; i < opts.length; i++) {
                                var val = String(opts[i]).trim();
                                var valLower = val.toLowerCase();
                                if (
                                    valLower.includes('seater') || valLower.includes('seat') ||
                                    valLower.includes('sectional') || valLower.includes('l shape') || valLower.includes('l-shape') ||
                                    valLower.includes('recliner') || valLower.includes('sofa bed') || valLower.includes('sofa cum bed') ||
                                    valLower.includes('king') || valLower.includes('queen') || valLower.includes('single') ||
                                    valLower.includes('door') || valLower.includes('drawer')
                                ) {
                                    if (!seating) seating = val;
                                } else {
                                    if (!col) col = val;
                                }
                            }

                            if (!seating && opts.length > 0) seating = String(opts[0]).trim();
                            if (!col && opts.length > 1) col = String(opts[1]).trim();
                            if (!col && seating && opts.length === 1 && v.title && v.title.includes('/')) {
                                var tParts = v.title.split('/');
                                if (tParts[1]) col = tParts[1].trim();
                            }

                            return {
                                seating: seating || v.option1 || v.title || '',
                                color: col || v.option2 || ''
                            };
                        }

                        // Group variants by Seating option
                        var primaryVariants = [];
                        var seenSeating = new Set();

                        for (var i = 0; i < pData.variants.length; i++) {
                            var v = pData.variants[i];
                            var details = getVariantDetails(v);
                            var seatName = details.seating;
                            var seatKey = seatName.toLowerCase();
                            if (seatKey && !seenSeating.has(seatKey)) {
                                seenSeating.add(seatKey);
                                primaryVariants.push({ variant: v, optionName: seatName });
                            }
                        }

                        if (primaryVariants.length <= 1) {
                            return [el];
                        }

                        var expandedCards = [];
                        for (var j = 0; j < primaryVariants.length; j++) {
                            var item = primaryVariants[j];
                            var vObj = item.variant;
                            var optName = item.optionName;

                            var cloned = el.cloneNode(true);
                            cloned.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'scroll-trigger--offscreen');
                            cloned.style.opacity = '1';
                            cloned.style.visibility = 'visible';
                            cloned.style.transform = 'none';
                            cloned.style.display = 'flex';
                            cloned.setAttribute('data-tags', el.getAttribute('data-tags') || '');
                            cloned.setAttribute('data-variant-expanded-id', vObj.id);
                            cloned.setAttribute('data-variant-option-name', optName);
                            cloned.setAttribute('data-variant-title', vObj.title || optName);
                            if (vObj.option1) cloned.setAttribute('data-variant-option1', vObj.option1);
                            if (vObj.option2) cloned.setAttribute('data-variant-option2', vObj.option2);
                            if (vObj.option3) cloned.setAttribute('data-variant-option3', vObj.option3);

                            // Find ALL variants that belong to this seating capacity (e.g. 5 Seater or Sectional Sofa)
                            var matchingVariants = (pData.variants || []).filter(function(v) {
                                var det = getVariantDetails(v);
                                return det.seating.toLowerCase() === optName.toLowerCase();
                            });

                            // Collect ALL unique colors available for this seating capacity
                            var colorVariantList = [];
                            var seenColors = new Set();
                            matchingVariants.forEach(function(v) {
                                var det = getVariantDetails(v);
                                var colName = det.color;
                                if (colName) {
                                    var colKey = colName.toLowerCase().trim();
                                    if (!seenColors.has(colKey)) {
                                        seenColors.add(colKey);
                                        colorVariantList.push({
                                            colorName: colName,
                                            colorKey: colKey,
                                            variant: v
                                        });
                                    }
                                }
                            });

                            // Rebuild swatches for this card if color swatches exist
                            var cardSwatchWrap = cloned.querySelector('.card-swatch');
                            if (cardSwatchWrap && colorVariantList.length > 0) {
                                var totalColors = colorVariantList.length;
                                var swHtml = '<ul class="swatch list-unstyled">';

                                var initialList = colorVariantList.slice(0, 4);
                                initialList.forEach(function(cItem, idx) {
                                    var cVariant = cItem.variant;
                                    var cName = cItem.colorName;
                                    var cHandle = cName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
                                    var cImg = getVariantImageSrc(cVariant, pData, cloned) || '';
                                    var isAct = String(cVariant.id) === String(vObj.id) || idx === 0;

                                    var patternStyle = originalStyleMap[cHandle] || originalStyleMap[cName.toLowerCase()] || ('background-color: ' + (cName.split(' ').pop().toLowerCase()) + ';');

                                    swHtml += '<li class="item">' +
                                        '<div class="item-wrapper clearfix">' +
                                            '<label class="swatch-label' + (isAct ? ' is-active' : '') + '" ' +
                                                'data-value="' + cHandle + '" ' +
                                                'data-variant-id="' + cVariant.id + '" ' +
                                                'title="' + cName + '" ' +
                                                (cImg ? 'data-variant-img="' + cImg + '"' : '') + '>' +
                                                '<span class="pattern" style="' + patternStyle + '"></span>' +
                                                cHandle +
                                            '</label>' +
                                            '<span class="tooltip">' + cName + '</span>' +
                                        '</div>' +
                                    '</li>';
                                });

                                if (totalColors > 4) {
                                    swHtml += '<li class="group-swatch" style="display: none;">';
                                    var extraList = colorVariantList.slice(4);
                                    extraList.forEach(function(cItem) {
                                        var cVariant = cItem.variant;
                                        var cName = cItem.colorName;
                                        var cHandle = cName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
                                        var cImg = getVariantImageSrc(cVariant, pData, cloned) || '';
                                        var isAct = String(cVariant.id) === String(vObj.id);

                                        var patternStyle = originalStyleMap[cHandle] || originalStyleMap[cName.toLowerCase()] || ('background-color: ' + (cName.split(' ').pop().toLowerCase()) + ';');

                                        swHtml += '<div class="item-wrapper clearfix" style="display:inline-block;margin-right:5px;">' +
                                            '<label class="swatch-label' + (isAct ? ' is-active' : '') + '" ' +
                                                'data-value="' + cHandle + '" ' +
                                                'data-variant-id="' + cVariant.id + '" ' +
                                                'title="' + cName + '" ' +
                                                (cImg ? 'data-variant-img="' + cImg + '"' : '') + '>' +
                                                '<span class="pattern" style="' + patternStyle + '"></span>' +
                                                cHandle +
                                            '</label>' +
                                            '<span class="tooltip">' + cName + '</span>' +
                                        '</div>';
                                    });
                                    swHtml += '</li>';

                                    swHtml += '<li class="item-swatch-more item">' +
                                        '<button type="button" class="number-showmore" title="More Color"><span>+</span> <span class="text-number">' + (totalColors - 4) + '</span></button>' +
                                    '</li>';
                                }

                                swHtml += '</ul>';
                                cardSwatchWrap.innerHTML = swHtml;

                                // Add showmore button handler
                                var moreBtn = cardSwatchWrap.querySelector('.number-showmore');
                                if (moreBtn) {
                                    moreBtn.addEventListener('click', function(e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        var grp = cardSwatchWrap.querySelector('.group-swatch');
                                        if (grp) {
                                            grp.style.display = 'inline-block';
                                            moreBtn.closest('li').style.display = 'none';
                                        }
                                    });
                                }
                            }

                            // Attach interactive swatch click listener to switch color on this card
                            (function(cardNode, cardPData) {
                                var sws = cardNode.querySelectorAll('.swatch-label');
                                sws.forEach(function(sw) {
                                    sw.addEventListener('click', function(e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        var vId = sw.getAttribute('data-variant-id');
                                        var foundV = (cardPData.variants || []).find(function(v) { return String(v.id) === String(vId); });
                                        if (foundV) {
                                            sws.forEach(function(l) { l.classList.remove('is-active'); });
                                            sw.classList.add('is-active');
                                            syncCardVariantDisplay(cardNode, { variant: foundV, pData: cardPData });
                                        }
                                    });
                                });
                            })(cloned, pData);

                            // Remove any rogue span from image overlay link
                            var rogueSpans = cloned.querySelectorAll('.card-media [data-change-title], .card-link [data-change-title]');
                            rogueSpans.forEach(function(sp) { sp.remove(); });

                            // Sync card price, EMI, photo, and link to this variant
                            syncCardVariantDisplay(cloned, { variant: vObj, pData: pData });

                            // Update title label on the actual card title heading (e.g. Arlo Three Seater Sofa In Green Velvet - 3+2)
                            var titleEl = cloned.querySelector('.card-title, .card__heading a, .product-title');
                            if (titleEl && optName) {
                                var changeSpan = titleEl.querySelector('[data-change-title]');
                                if (changeSpan) {
                                    changeSpan.textContent = ' - ' + optName;
                                } else {
                                    var span = document.createElement('span');
                                    span.setAttribute('data-change-title', '');
                                    span.textContent = ' - ' + optName;
                                    titleEl.appendChild(span);
                                }
                            }

                            expandedCards.push(cloned);
                        }

                        return expandedCards;
                    } catch(e) {
                        return [el];
                    }
                }

                function addProducts(els) {
                    els.forEach(function(el) {
                        var a = el.querySelector('a[href*="/products/"]');
                        var h = a ? a.getAttribute('href').split('/products/')[1] : null;
                        if (h) { h = h.split('?')[0].split('#')[0]; }
                        var baseKey = h || el.textContent.trim().slice(0, 60);

                        var expanded = expandProductVariants(el);
                        expanded.forEach(function(itemEl) {
                            itemEl.setAttribute('data-base-product-handle', baseKey);
                            var varId = itemEl.getAttribute('data-variant-expanded-id') || 'base';
                            var uniqueKey = baseKey + '-' + varId;
                            if (seen.has(uniqueKey)) return;
                            seen.add(uniqueKey);
                            rawLoadedProducts.push(itemEl);
                        });
                    });
                }

                function finishLoading() {
                    if (thisFetchId !== activeFetchId) return;

                    // Combine all pages in exact sequential order
                    rawLoadedProducts = [];
                    seen.clear();
                    var pageKeys = Object.keys(pagesData).map(Number).sort(function(a, b) { return a - b; });
                    for (var k = 0; k < pageKeys.length; k++) {
                        var p = pageKeys[k];
                        if (pagesData[p] && pagesData[p].length > 0) {
                            addProducts(pagesData[p]);
                        }
                    }

                    isFetching = false;
                    applyFiltersAndSort(false);
                    if (resultsHeading) {
                        resultsHeading.textContent = 'Results';
                    }
                }

                function buildPageUrl(base, page) {
                    var cleanBase = base.split('?')[0];
                    if (base.includes('/search') || base.includes('?')) {
                        var queryString = base.includes('?') ? base.split('?')[1] : '';
                        var params = new URLSearchParams(queryString);
                        if (page > 1) {
                            params.set('page', page);
                        } else {
                            params.delete('page');
                        }
                        var resQuery = params.toString();
                        return cleanBase + (resQuery ? '?' + resQuery : '');
                    } else {
                        return cleanBase + (page > 1 ? '?page=' + page : '');
                    }
                }

                function fetchPagesInBatches(baseUrl, startPage, onComplete) {
                    var concurrency = 3;
                    var currentStart = startPage;
                    var emptyStreak = 0;

                    function nextBatch() {
                        if (thisFetchId !== activeFetchId) return;

                        var batch = [];
                        for (var b = 0; b < concurrency; b++) {
                            batch.push(currentStart + b);
                        }

                        var promises = batch.map(function(page) {
                            var pUrl = buildPageUrl(baseUrl, page);
                            return fetch(pUrl)
                                .then(function(res) { return res.ok ? res.text() : ''; })
                                .then(function(pHtml) {
                                    if (!pHtml) return { page: page, els: [] };
                                    return { page: page, els: extractPageElements(pHtml) };
                                })
                                .catch(function() {
                                    return { page: page, els: [] };
                                });
                        });

                        Promise.all(promises).then(function(results) {
                            if (thisFetchId !== activeFetchId) return;

                            results.sort(function(a, b) { return a.page - b.page; });

                            var batchHadItems = false;
                            for (var j = 0; j < results.length; j++) {
                                var r = results[j];
                                if (r.els && r.els.length > 0) {
                                    pagesData[r.page] = r.els;
                                    addProducts(r.els);
                                    batchHadItems = true;
                                }
                            }

                            // Progressive UI render so count updates live
                            applyFiltersAndSort(false);

                            if (batchHadItems) {
                                emptyStreak = 0;
                            } else {
                                emptyStreak++;
                            }

                            if (emptyStreak < 2 && currentStart < 60) {
                                currentStart += concurrency;
                                nextBatch();
                            } else {
                                onComplete();
                            }
                        });
                    }

                    nextBatch();
                }

                // Step 1: Fetch Page 1
                var page1Url = buildPageUrl(targetUrl, 1);
                fetch(page1Url)
                    .then(function(r) { return r.ok ? r.text() : ''; })
                    .then(function(html) {
                        if (thisFetchId !== activeFetchId) return;
                        var p1Els = html ? extractPageElements(html) : [];
                        
                        if (p1Els.length > 0) {
                            pagesData[1] = p1Els;
                            addProducts(p1Els);
                            applyFiltersAndSort(false);

                            // Fetch all subsequent pages dynamically in batches
                            fetchPagesInBatches(targetUrl, 2, finishLoading);
                        } else {
                            rawLoadedProducts = [];
                            currentFilteredProducts = [];
                            isFetching = false;
                            renderCurrentPage();
                        }
                    })
                    .catch(function(err) {
                        console.warn('Initial fetch error:', err);
                        if (thisFetchId !== activeFetchId) return;
                        rawLoadedProducts = [];
                        currentFilteredProducts = [];
                        isFetching = false;
                        renderCurrentPage();
                    });
            }

            function clearSearchInput() {
                currentSearchQuery = '';
                if (searchLandingInput) {
                    searchLandingInput.value = '';
                }
                var allLandingInputs = document.querySelectorAll('#Search-In-Landing, .search-landing-form input[name="q"]');
                allLandingInputs.forEach(function(inp) {
                    inp.value = '';
                });
                if (typeof window.hidePredictiveSearch === 'function') {
                    window.hidePredictiveSearch();
                }
                document.dispatchEvent(new CustomEvent('predictive-search:hide'));
                var psDrop = document.querySelector('.predictive-search-dropdown');
                if (psDrop) {
                    psDrop.style.display = 'none';
                    psDrop.innerHTML = '';
                }
            }

            function bindEvents() {
                var backBtn = dynamicList.querySelector('.back-to-top-btn');
                if (backBtn) {
                    backBtn.addEventListener('click', function() {
                        clearSearchInput();
                        if (window.history && window.history.pushState) {
                            window.history.pushState(null, '', '/search?cat=all');
                        }
                        renderSidebar('top', '/collections/all');
                        loadProducts('All Categories', '/collections/all');
                    });
                }

                var links = dynamicList.querySelectorAll('.search-cat-link');
                links.forEach(function(link) {
                    link.addEventListener('click', function(e) {
                        e.preventDefault();
                        clearSearchInput();
                        var name   = link.textContent.trim();
                        var url    = link.getAttribute('href');
                        var catKey = link.getAttribute('data-cat-key');

                        if (window.history && window.history.pushState) {
                            window.history.pushState(null, '', '/search?cat=' + encodeURIComponent(catKey || name));
                        }

                        if (catKey && categoryDataMap[catKey]) {
                            renderSidebar(catKey, url);
                        } else {
                            links.forEach(function(l) { l.parentElement.classList.remove('is-active'); });
                            link.parentElement.classList.add('is-active');
                        }
                        loadProducts(name, url);
                    });
                });
            }

            function initMobileFilterDrawer() {
                var openBtn = document.getElementById('mobile-filter-open-btn');
                var closeBtn = document.getElementById('sidebar-mobile-close');
                var applyBtn = document.getElementById('btn-mobile-apply-filters');
                var sidebar = document.getElementById('search-category-sidebar');
                var backdrop = document.getElementById('search-sidebar-backdrop');

                function openDrawer() {
                    if (sidebar) sidebar.classList.add('is-open');
                    if (backdrop) backdrop.classList.add('is-open');
                    document.body.style.overflow = 'hidden';
                }

                function closeDrawer() {
                    if (sidebar) sidebar.classList.remove('is-open');
                    if (backdrop) backdrop.classList.remove('is-open');
                    document.body.style.overflow = '';
                }

                if (openBtn) openBtn.addEventListener('click', openDrawer);
                if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
                if (applyBtn) applyBtn.addEventListener('click', closeDrawer);
                if (backdrop) backdrop.addEventListener('click', closeDrawer);
            }

            initAccordionToggles();
            initFilterEventListeners();
            initMobileFilterDrawer();

            // Resolve initial URL parameters (cat, category, OR search query q)
            var urlParams  = new URLSearchParams(window.location.search);
            var catParam   = urlParams.get('cat') || urlParams.get('category');
            var qParam     = urlParams.get('q');

            if (catParam) {
                clearSearchInput();
                if (catParam.toLowerCase() === 'all') {
                    renderSidebar('top', '/collections/all');
                    loadProducts('All Categories', '/collections/all');
                } else {
                    var resolved = (typeof resolveCategoryParam === 'function') ? resolveCategoryParam(catParam) : null;
                    if (resolved) {
                        renderSidebar(resolved.groupKey, resolved.item.url);
                        loadProducts(resolved.item.name, resolved.item.url);
                    } else {
                        renderSidebar('top', '/collections/all');
                        loadProducts(catParam, '/search?q=' + encodeURIComponent(catParam) + '&type=product');
                    }
                }
            } else if (qParam && qParam.trim() !== '') {
                var cleanQ = qParam.trim();
                currentSearchQuery = cleanQ;
                if (searchLandingInput) {
                    searchLandingInput.value = cleanQ;
                }
                renderSidebar('top', '/collections/all');
                loadProducts(cleanQ, '/search?q=' + encodeURIComponent(cleanQ) + '&type=product');
            } else {
                clearSearchInput();
                renderSidebar('top', '/collections/all');
                loadProducts('Best Sellers', '/collections/all');
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initCategoryScript);
        } else {
            initCategoryScript();
        }

        // Real-time Shopify Theme Customizer block updates
        document.addEventListener('shopify:section:load', function(e) {
            initCategoryScript();
        });
        document.addEventListener('shopify:block:select', function(e) {
            initCategoryScript();
        });
        document.addEventListener('shopify:block:deselect', function(e) {
            initCategoryScript();
        });
    })();